import {FetchUtil} from "../../pages/public/fetch_util";
import success from "../../iconfont/success";

const DOMAIN = process.env.REACT_APP_CLOUD_DOMAIN;

const doPost = (url, bodyType, bodyData, success, error, docatch) => {
    let fetchUtil = new FetchUtil();
    fetchUtil.init()
        .setUrl(url)
        .setMethod("POST")
        .setCookieCors()
        .setBodyType(bodyType)
        .setBody(bodyData)
        .dofetch()
        .then((msg) => {
            if (msg.respCode == 0) {
                if (success) {
                    success(msg.respMsg)
                }
            } else {
                if (error) {
                    error(msg)
                }
            }
        })
        .catch((msg) => {
            if (docatch) {
                docatch(msg)
            } else if (error) {
                error(msg)
            }
        })
};

const doGet = (url, success, error, docatch) => {
    let fetchUtil = new FetchUtil();
    fetchUtil.init()
        .setUrl(url)
        .setMethod("GET")
        .setCookieCors()
        .setBodyType('json')
        .dofetch()
        .then((msg) => {
            if (msg.respCode == 0) {
                if (success) {
                    success(msg.respMsg)
                }
            } else {
                if (error) {
                    error(msg)
                }
            }
        })
        .catch((msg) => {
            if (docatch) {
                docatch(msg)
            } else if (error) {
                error(msg)
            }
        })
};

//席位
const URL_SEAT_VIEW_DATA = DOMAIN + '/wxw/seat/overview' // 席位概览
const URL_SEAT_LIST = DOMAIN + '/wxw/seat/seatlist' // 席位列表
const URL_SEAT_GROUP_NAMELIST = DOMAIN + '/wxw/seat/group/selectlist' // 席位分组下拉列表
const URL_SEAT_GROUP_LIST = DOMAIN + '/wxw/seat/group/list' // 席位分组详情
const URL_SEAT_ADD_GROUP = DOMAIN + '/wxw/seat/group/add' // 新建席位分组
const URL_SEAT_EDIT_GROUP = DOMAIN + '/wxw/seat/group/edit' // 编辑席位分组
const URL_SEAT_DELETE_GROUP = DOMAIN + '/wxw/seat/group/del' // 删除席位分组
const URL_SEAT_SET_GROUP = DOMAIN + '/wxw/seat/groupseat' // 批量分组席位
const URL_SEAT_LOGIN = DOMAIN + '/wxw/seat/login' // 登录席位
const URL_SEAT_QUIT = DOMAIN + '/wxw/seat/quit' // 下线席位
const URL_SEAT_PRODUCT_INFO = DOMAIN + '/wxw/order/productinfo' // 购买席位信息
const URL_SEAT_CALC_PRICE = DOMAIN + '/wxw/order/calprice' // 席位计价
const URL_SEAT_GET_ORDER = DOMAIN + '/wxw/order/unified' // 席位购买下单
const URL_SEAT_PAY_CODE = DOMAIN + '/wxw/order/paycode' // 席位收款二维码
const URL_SEAT_PAY_RESULT = DOMAIN + '/wxw/order/payresult' // 查询支付结果
const URL_SEAT_LOGIN_STATUS = DOMAIN + '/wxw/seat/loginstatus' // 登录席位状态
const URL_SEAT_BIND_NAME = DOMAIN + '/wxw/seat/bindname' // 绑定公司名称
const URL_SEAT_GIFT_STATUS = DOMAIN + '/wxw/seat/freshgiftstatus' //新人专属优惠领取状态
const URL_SEAT_GIFT_RECEIVE = DOMAIN + '/wxw/seat/receivefreshgift' //领取新人专属优惠
const URL_SEAT_EXPIRING_SEATS = DOMAIN + '/wxw/seat/expiring_seats'//获取即将过期的席位

//账号运营
const URL_ACCOUNT_LIST = DOMAIN + '/wxw/account/list'  //账号列表
const URL_ACCOUNT_AUTOFRIEND = DOMAIN + '/wxw/account/autofriend'  //设置自动通过好友请求
const URL_ACCOUNT_REMARK_LIST = DOMAIN + '/wxw/account/remark/list'  //好友备注列表
const URL_ACCOUNT_REMARK_RULE_NAMELIST = DOMAIN + '/wxw/account/remark/namelist'  //好友备注 规则下拉列表
const URL_ACCOUNT_REMARK_REPORT_LIST = DOMAIN + '/wxw/account/remark/record'  //好友备注 规则数据
const URL_ACCOUNT_REMARK_CREATE = DOMAIN + '/wxw/account/remark/create'  //好友备注 新建好友备注规则
const URL_ACCOUNT_REMARK_EDIT = DOMAIN + '/wxw/account/remark/edit'  //好友备注  编辑好友备注规则
const URL_ACCOUNT_REMARK_ACCOUNT_NAMELIST = DOMAIN + '/wxw/account/remark/accountlist'  //好友备注 账号下拉
const URL_ACCOUNT_REMARK_DELETE = DOMAIN + '/wxw/account/remark/del'  //好友备注 规则删除
const URL_ACCOUNT_REMARK_DETAIL = DOMAIN + '/wxw/account/remark/detail'  //好友备注 规则详情
const URL_ACCOUNT_REMARK_REPORT_ACCOUNT_NAMELIST = DOMAIN + '/wxw/account/remark/taskAccountList'  //好友备注 数据统计 账号下拉
const URL_ACCOUNT_REMARK_MODIFY_STATUS = DOMAIN + '/wxw/account/remark/modifystatus'  //开启/关闭新好友运营任务

//拓客引流
const URL_ACCOUNT_GET_ACCOUNT_LIST = DOMAIN + '/wxw/account/getAccountList' //14 获取账号列表

//拓客引流
const URL_ACCOUNT_PHONE_FRIEND_LIST = DOMAIN + '/wxw/account/phonefriend/list'//08 手机号添加好友任务列表
const URL_ACCOUNT_PHONE_FRIEND_CREATE = DOMAIN + '/wxw/account/phonefriend/create'//07 手机号添加好友任务
const URL_ACCOUNT_PHONE_FRIEND_DETAIL = DOMAIN + '/wxw/account/phonefriend/detail'//获取任务详情
const URL_ACCOUNT_PHONE_FRIEND_EDIT = DOMAIN + '/wxw/account/phonefriend/edit'//任务的编辑
const URL_ACCOUNT_PHONE_FRIEND_STOP = DOMAIN + '/wxw/account/phonefriend/stop' //停止
const URL_ACCOUNT_PHONE_FRIEND_CORP_TAGS = DOMAIN + '/wxw/account/phonefriend/corptags' //07.4 获取标签列表
const URL_ACCOUNT_PHONE_FRIEND_NAME_LIST = DOMAIN + '/wxw/account/phonefriend/namelist'//08.1 手机号添加好友任务名称列表
const URL_ACCOUNT_PHONE_FRIEND_TASK_INFO = DOMAIN + '/wxw/account/phonefriend/taskinfo'//09 手机号添加好友任务信息
const URL_ACCOUNT_PHONE_FRIEND_PHONE_RECORD = DOMAIN + '/wxw/account/phonefriend/phonerecord'//10 手机号添加好友任务手机号数据
const URL_ACCOUNT_PHONE_FRIEND_TASK_ACCOUNT = DOMAIN + '/wxw/account/phonefriend/taskaccount'//09.1 手机号添加好友任务账号列表
const URL_ACCOUNT_PHONE_FRUEND_OPEN = DOMAIN + '/wxw/account/phonefriend/open' //手机号添加好友任务开启
const URL_ACCOUNT_PHONE_FRIEND_DEL = DOMAIN + '/wxw/account/phonefriend/del' //手机号加好友删除任务
//群加好友
const URL_ACCOUNT_GROUP_FRIEND_DEL = DOMAIN + '/wxw/account/groupfriend/del'
const URL_ACCOUNT_GROUP_FRIEND_LIST = DOMAIN + '/wxw/account/groupfriend/list'//12 群成员添加好友任务列表
const URL_ACCOUNT_GROUNP_FRIEND_GROUP_CHAT_LIST = DOMAIN + '/wxw/account/groupfriend/groupchatlist'//16 获取全部外部群聊列表
const URL_ACCOUNT_GROUP_FRIEND_CREATE = DOMAIN + '/wxw/account/groupfriend/create'//11 群成员添加好友任务
const URL_ACCOUNT_GROUP_FRIEND_DETAIL = DOMAIN + '/wxw/account/groupfriend/detail'//11.2 群成员添加好友任务详情
const URL_ACCOUNT_GROUP_FRIEND_EDIT = DOMAIN + '/wxw/account/groupfriend/edit'//11.1 群成员添加好友任务编辑
const URL_ACCOUNT_GROUP_FRIEND_STOP = DOMAIN + '/wxw/account/groupfriend/stop'//11.3 群成员添加好友任务停止
const URL_ACCOUNT_GROUP_FRIEND_NAME_LIST = DOMAIN + '/wxw/account/groupfriend/namelist'//15.3 群聊添加好友任务名称列表
const URL_ACCOUNT_GROUP_FRIEND_TASK_INFO = DOMAIN + '/wxw/account/groupfriend/taskinfo'//13 群聊添加好友任务信息
const URL_ACCOUNT_GROUP_FRIEND_GROUP_LIST = DOMAIN + '/wxw/account/groupfriend/groupList'//15 群聊添加好友任务群聊数据
const URL_ACCOUNT_GROUP_FRIEND_MEMBER_LIST = DOMAIN + '/wxw/account/groupfriend/memberList' //14 群聊添加好友任务群成员数据
const URL_ACCOUNT_GROUP_FRIEND_GROUP_CHAT_DEL = DOMAIN + '/wxw/account/groupfriend/groupchatdel'//15.1 群聊添加好友任务删除群聊
const URL_ACCOUNT_GROUP_FRIEND_GROUP_CHAT_STOP = DOMAIN + '/wxw/account/groupfriend/groupchatstop'//15.2 群聊添加好友任务停止群聊任务
const URL_ACCOUNT_GROUP_FRIEND_OPEN = DOMAIN + '/wxw/account/groupfriend/open' //11.4 群成员添加好友任务开启
const URL_ACCOUNT_GROUP_FRIEND_ROOM_MEMBER_LIST = DOMAIN + '/wxw/account/groupfriend/roomMemberList' //获取群成员列表

//客户触达  关键词回复
const URL_CUSTOMER_KEYWORD = DOMAIN + '/wxw/keywords/list' // 规则列表
const URL_CUSTOMER_KEYWORD_SWITCH = DOMAIN + '/wxw/keywords/switch' // 规则列表
const URL_CUSTOMER_KEYWORD_CREATE = DOMAIN + '/wxw/keywords/create' // 创建任务
const URL_CUSTOMER_KEYWORD_EDIT = DOMAIN + '/wxw/keywords/edit' // 编辑任务
const URL_CUSTOMER_KEYWORD_DETAIL = DOMAIN + '/wxw/keywords/detail' // 获取任务详情
const URL_CUSTOMER_KEYWORD_DELETE = DOMAIN + '/wxw/keywords/delete' // 删除任务
const URL_CUSTOMER_KEYWORD_REPORT = DOMAIN + '/wxw/keywords/ruledata' // 规则数据
const URL_CUSTOMER_KEYWORD_REPORT_NAMELIST = DOMAIN + '/wxw/keywords/namelist' // 规则数据下拉列表
//客户触达  好友群发
const URL_CUSTOMER_GROUPSEND_CREATE = DOMAIN + '/wxw/groupmsg/create' //创建活动
const URL_CUSTOMER_GROUPSEND_EDIT = DOMAIN + '/wxw/groupmsg/edit' //创建活动
const URL_CUSTOMER_GROUPSEND_DELETE = DOMAIN + '/wxw/groupmsg/delete' //删除任务
const URL_CUSTOMER_GROUPSEND_STOP = DOMAIN + '/wxw/groupmsg/stop' //停止任务
const URL_CUSTOMER_GROUPSEND_OPEN = DOMAIN + '/wxw/groupmsg/open' //开启任务
const URL_CUSTOMER_GROUPSEND_LIST = DOMAIN + '/wxw/groupmsg/list' //任务列表
const URL_CUSTOMER_GROUPSEND_DETAIL = DOMAIN + '/wxw/groupmsg/detail' //活动详情
const URL_CUSTOMER_GROUPSEND_COUNTCUSTOMER = DOMAIN + '/wxw/groupmsg/countCusotmer' // 统计客户
const URL_CUSTOMER_GROUPSEND_STATS = DOMAIN + '/wxw/groupmsg/stat' // 群发统计
const URL_CUSTOMER_GROUPSEND_NAMELIST = DOMAIN + '/wxw/groupmsg/namelist' // 活动下拉
const URL_CUSTOMER_GROUPSEND_REPORTLIST = DOMAIN + '/wxw/groupmsg/record' // 群发列表
const URL_CUSTOMER_GROUPSEND_ACCOUNTLIST = DOMAIN + '/wxw/groupmsg/accountList' // 账号下拉

//群SOP
const URL_GROUP_TAG_QUERY = DOMAIN + '/wxw/grouptag/query'//获取群的标签
const URL_GROUP_SOP_QUERY_ROOM = DOMAIN + '/wxw/groupsop/queryroom'//20 群聊筛选列表
const URL_GROUP_MANAGER_MANAGE_LIST = DOMAIN + '/wxw/groupmanager/managerlist'//05.1 群管理员列表
const URL_GROUP_SOP_TASK_LIST = DOMAIN + '/wxw/groupsop/tasklist'//04 获取群聊SOP任务列表
const URL_GROUP_SOP_NAME_LIST = DOMAIN + '/wxw/groupsop/namelist'//07 群聊SOP任务名称列表
const URL_GROUP_SOP_CREATE = DOMAIN + '/wxw/groupsop/create'//01 创建群聊SOP任务
const URL_GROUP_SOP_RADIO = DOMAIN + '/wxw/groupsop/radio'//05 关闭群聊SOP任务
const URL_GROUP_SOP_DETAIL = DOMAIN + '/wxw/groupsop/detail' //02 获取群聊SOP任务详情
const URL_GROUP_SOP_EDIT = DOMAIN + '/wxw/groupsop/edit' //03 编辑群聊SOP任务
const URL_GROUP_SOP_DEL = DOMAIN + '/wxw/groupsop/del' //06 删除群聊SOP任务
const URL_GROUP_SOP_GROUPS = DOMAIN + '/wxw/groupsop/groups' //08 群聊管理
const URL_GROUP_SOP_TASK_TYPE = DOMAIN + '/wxw/groupsop/tasktype' //07.1 群聊SOP任务群过滤类型
const URL_GROUP_SOP_EDIT_TAG_FILTER = DOMAIN + '/wxw/groupsop/edittagfilter' //群聊管理修改过滤标签
const URL_GROUP_SOP_EDIT_GROUP = DOMAIN + '/wxw/groupsop/editgroup' //10 群聊管理修改群聊
const URL_GROUP_SOP_DEL_GROUP = DOMAIN + '/wxw/groupsop/delgroup' //09 群聊管理移除群聊
const URL_GROUP_SOP_GROUP_DATA = DOMAIN + '/wxw/groupsop/groupdata' //12 群聊详情
const URL_GROUP_SOP_GROUP_PUSh = DOMAIN + '/wxw/groupsop/grouppush'//群聊推送详情 后改的群搜的数据
const URL_GROUP_SOP_MANAGER_DATA = DOMAIN + '/wxw/groupsop/managerdata' //16 成员详情
const URL_GROUP_SOP_GROUP_PUSH = DOMAIN + '/wxw/groupsop/grouppush' //14 群聊推送详情
const URL_GROUP_SOP_MANAGER_GROUP = DOMAIN + '/wxw/groupsop/managergroup' //19 管理员群聊列表
const URL_GROUP_SOP_MANAGER_PUSH = DOMAIN + '/wxw/groupsop/managerpush' //18 管理员推送详情

//群管理
const URL_GROUP_MANAGE_LIST = DOMAIN + '/wxw/groupmanager/list' //群列表
const URL_GROUP_MANAGE_GROUPTAG = DOMAIN + '/wxw/grouptag/query' //群标签
const URL_GROUP_MANAGE_ADD_TAG = DOMAIN + '/wxw/groupmanager/batchTag' //批量打标签
const URL_GROUP_MANAGE_DELETE_TAG = DOMAIN + '/wxw/groupmanager/batchRemoveTag' //批量移除标签
const URL_GROUP_SYNC_MANAGE_LIST = DOMAIN + '/wxw/groupmanager/syncGroup' //同步群聊列表
const URL_GROUP_GROUPMANAGER_LIST = DOMAIN + '/wxw/groupmanager/managerlist' //群管理员列表
const URL_GROUP_GROUPOWNER_LIST = DOMAIN + '/wxw/groupmanager/ownerlist' //群主列表
const URL_GROUP_GROUPMANAGER_CHANGE = DOMAIN + '/wxw/groupmanager/transmanage' //群管理员变更管理
const URL_GROUP_GROUPOWNER_CHANGE = DOMAIN + '/wxw/groupmanager/transowner' //群管理员变更管理
const URL_GROUP_GROUPACCOUNT_LIST = DOMAIN + '/wxw/groupmanager/accountlist' //管理账号列表
const URL_GROUP_GROUPACCOUNT_ADDTAG = DOMAIN + '/wxw/grouptag/addtag' //管理账号列表
//群标签
const URL_GROUP_TAGLIST_CHANGE_ORDER = DOMAIN + '/wxw/grouptag/taggrouporder' // 交换顺序
const URL_GROUP_TAGLIST_ADD = DOMAIN + '/wxw/grouptag/addtag' // 添加标签
const URL_GROUP_TAGLIST_EDIT = DOMAIN + '/wxw/grouptag/edit' // 编辑群标签组
const URL_GROUP_TAGLIST_SAVE = DOMAIN + '/wxw/grouptag/save' // 创建群标签组
const URL_GROUP_TAGLIST_DELETE = DOMAIN + '/wxw/grouptag/delete' // 删除群标签组
//社群群发
const URL_GROUP_SEND_LIST = DOMAIN + '/wxw/roommessage/tasklist' //群聊群发任务列表
const URL_GROUP_SEND_NAME_LIST = DOMAIN + '/wxw/roommessage/namelist' //任务下拉
const URL_GROUP_SEND_REPORT_STATS = DOMAIN + '/wxw/roommessage/taskoverview' //群发统计
const URL_GROUP_SEND_REPORT_LIST = DOMAIN + '/wxw/roommessage/taskrecord' //群发统计列表
const URL_GROUP_SEND_REPORT_ACCOUNT_NAMELIST = DOMAIN + '/wxw/roommessage/managerList' //群发统计列表
const URL_GROUP_SEND_OPEN_TASK = DOMAIN + '/wxw/roommessage/starttask' //开启活动
const URL_GROUP_SEND_STOP_TASK = DOMAIN + '/wxw/roommessage/stoptask' //停止活动
const URL_GROUP_SEND_DELETE_TASK = DOMAIN + '/wxw/roommessage/deltask' //删除活动
const URL_GROUP_SEND_CREATE = DOMAIN + '/wxw/roommessage/create' //创建群聊群发任务
const URL_GROUP_SEND_EDIT = DOMAIN + '/wxw/roommessage/edit' //编辑群聊群发任务
const URL_GROUP_SEND_DETAIL = DOMAIN + '/wxw/roommessage/detail' //群聊群发任务详情


//Sop模板
const URL_SOP_TEMPLATE_LIST = DOMAIN + '/wxw/soptemplate/list'   // sop模板消息列表
const URL_SOP_TEMPLATE_CREATE = DOMAIN + '/wxw/soptemplate/create'  //sop模板消息创建
const URL_SOP_TEMPLATE_EDIT = DOMAIN + '/wxw/soptemplate/edit'  //sop模板消息编辑
const URL_SOP_TEMPLATE_DETAIL = DOMAIN + '/wxw/soptemplate/detail' //获取sop模板的详情
const URL_SOP_TEMPLATE_DEL = DOMAIN + '/wxw/soptemplate/del' //删除sop模板
const URL_SOP_TEMPLATE_NAME_LIST = DOMAIN + '/wxw/soptemplate/namelist' //获取SOP模板名称列表
//好友sop
const URL_FRIEND_SOP_TASK_LIST = DOMAIN + '/wxw/friendsop/tasklist' //04 获取好友SOP任务列表
const URL_FRIEND_SOP_CREATE = DOMAIN + '/wxw/friendsop/create' //01 创建好友SOP任务
const URL_FRIEND_SOP_RADIO = DOMAIN + '/wxw/friendsop/radio' //05 开关好友SOP任务
const URL_FRIEND_SOP_DEL = DOMAIN + '/wxw/friendsop/del' //06 删除好友SOP任务
const URL_FRIEND_SOP_NAME_LIST = DOMAIN + '/wxw/friendsop/namelist' //07 好友SOP任务名称列表
const URL_FRIEND_SOP_MANAGER_LIST = DOMAIN + '/wxw/friendsop/managerlist' //08 管理账号名称列表
const URL_FRIEND_SOP_DETAIL = DOMAIN + '/wxw/friendsop/detail' //02 获取好友SOP任务详情
const URL_FRIEND_SOP_EDIT = DOMAIN + '/wxw/friendsop/edit' //03 编辑好友SOP任务
const URL_FRIEND_SOP_PUSH_DATA = DOMAIN + '/wxw/friendsop/pushdata' //12 数据详情
const URL_FRIEND_SOP_CUSTOMER_NUM = DOMAIN + '/wxw/friendsop/customernum' //查看人数


//黑名单
const URL_GROUP_BLACK_LIST_CUSTOMER_LIST = DOMAIN + '/wxw/group/blacklist/customerlist'//17 黑名单清单
const URL_GROUP_BLACK_LIST_DEL_CUSTOMER = DOMAIN + '/wxw/group/blacklist/delcustomer'//16 从黑名单移除客户
const URL_GROUP_BLACK_LIST_SELECT_CUSTOMER = DOMAIN + '/wxw/group/blacklist/selectcustomer' //15.1 黑名单客户列表
const URL_GROUP_BLACK_LIST_ADD_CUSTOMER = DOMAIN + '/wxw/group/blacklist/addcustomer'//15 手动添加客户到黑名单
//白名单
const URL_GROUP_WHITE_LIST_SELECT_CUSTOMER = DOMAIN + '/wxw/group/whitelist/selectcustomer'//15.2 白名单客户列表
const URL_GROUP_WHITE_LIST_CUSTOMER_LIST = DOMAIN + '/wxw/group/whitelist/customerlist' //20 白名单清单
const URL_GROUP_WHITE_LIST_ADD_CUSTOMER = DOMAIN + '/wxw/group/whitelist/addcustomer' //18 手动添加客户到白名单
const URL_GROUP_WHITE_LIST_DEL_CUSTOMER = DOMAIN + '/wxw/group/whitelist/delcustomer' //19 从白名单移除客户

const URL_GROUP_WHITE_LIST_CONTENT_LINK_LIST = DOMAIN + '/wxw/group/whitelist/content/linklist' //23 内容白名单网页清单
const URL_GROUP_WHITE_LIST_CONTENT_DEL_LINK = DOMAIN + '/wxw/group/whitelist/content/dellink' //22 从内容白名单移除网页
const URL_GROUP_WHITE_LIST_CONTENT_ADD_LINK = DOMAIN + '/wxw/group/whitelist/content/addlink' //21 添加内容白名单网页

const URL_GROUP_WHITE_LIST_CONTENT_APP_LIST = DOMAIN + '/wxw/group/whitelist/content/applist' //26 内容白名单小程序清单
const URL_GROUP_WHITE_LIST_CONTENT_ADD_APP = DOMAIN + '/wxw/group/whitelist/content/addapp' //24 添加内容白名单小程序
const URL_GROUP_WHITE_LIST_CONTENT_DEL_APP = DOMAIN + '/wxw/group/whitelist/content/delapp' //25 从内容白名单移除小程序

//违规检测
const URL_GROUPCHAT_ERRORCHECK_LIST = DOMAIN + '/wxw/group/msgcheck/tasklist'
const URL_GROUPCHAT_ERRORCHECK_DELETE = DOMAIN + '/wxw/group/msgcheck/del'
const URL_GROUPCHAT_ERRORCHECK_NAMELIST = DOMAIN + '/wxw/group/msgcheck/namelist'
const URL_GROUPCHAT_ERRORCHECK_CREATE = DOMAIN + '/wxw/group/msgcheck/create'
const URL_GROUPCHAT_ERRORCHECK_EDIT = DOMAIN + '/wxw/group/msgcheck/edit'
const URL_GROUPCHAT_ERRORCHECK_DETAIL = DOMAIN + '/wxw/group/msgcheck/detail'
const URL_GROUPCHAT_ERRORCHECK_REPORT_LIST = DOMAIN + '/wxw/group/msgcheck/recordlist'
const URL_GROUPCHAT_ERRORCHECK_SWITCH = DOMAIN + '/wxw/group/msgcheck/switch'

//群关键词
const URL_GROUPCHAT_KEYWORD_LIST = DOMAIN + '/wxw/account/group/keywordreply/list'
const URL_GROUPCHAT_KEYWORD_DELETE = DOMAIN + '/wxw/account/group/keywordreply/delete'
const URL_GROUPCHAT_KEYWORD_REPORT_LIST = DOMAIN + '/wxw/account/group/keywordreply/ruledata'
const URL_GROUPCHAT_KEYWORD_NAMELIST = DOMAIN + '/wxw/account/group/keywordreply/namelist'
const URL_GROUPCHAT_KEYWORD_ROOMLIST = DOMAIN + '/wxw/account/group/keywordreply/roomlist'
const URL_GROUPCHAT_KEYWORD_CREATE = DOMAIN + '/wxw/account/group/keywordreply/create'
const URL_GROUPCHAT_KEYWORD_DETAIL = DOMAIN + '/wxw/account/group/keywordreply/detail'
const URL_GROUPCHAT_KEYWORD_EDIT = DOMAIN + '/wxw/account/group/keywordreply/edit'
const URL_GROUPCHAT_KEYWORD_GROUPDETAIL_LIST = DOMAIN + '/wxw/account/group/keywordreply/roomlistPage'


//群管理转让群主列表
const URL_GROUPCHAT_MANAGE_OWNERLIST_NEW = DOMAIN + '/wxw/groupmanager/internalMembers'


//在线聊天
const URL_CHAT_USER_ID = DOMAIN + '/wxw/chat/getUserId'//获取用户Id
const URL_GET_CHAT_ACCOUNT_LIST = DOMAIN + '/wxw/chat/accountlist'//01 获取关联的账号
const URL_GET_CHAT_LIST = DOMAIN + '/wxw/chat/chatlist' //02 聊天对话列表
const URL_GET_CHAT_MSG = DOMAIN + '/wxw/chat/getMsgs' //03 获取消息列表
const URL_GET_CHAT_GET_FILE_URL = DOMAIN + '/wxw/chat/getFileUrl' //03 获取文件url

const URL_CHAT_END_CONVEER_SATION = DOMAIN + '/wxw/chat/endConveersation' //结束会话
const URL_CHAT_SET_TOP = DOMAIN + '/wxw/chat/setTop' //置顶
const URL_CHAT_SET_UNREAD = DOMAIN + '/wxw/chat/setUnRead'//设置消息未读
const URL_CHAT_SET_NOT_DISTURB = DOMAIN + '/wxw/chat/setNotDisturb'//设置消息免打扰
const URL_GET_CHAT_UPDATE_ROOM_NAME = DOMAIN + '/wxw/chat/updateRoomName'//23 修改群名称
const URL_CHAT_QUIT_ROOM = DOMAIN + '/wxw/chat/quitRoom' //退出群聊
const URL_CHAT_CLEAR_CHAT_LIST = DOMAIN + '/wxw/chat/clearChatList' //清空群聊

const URL_GET_CHAT_GET_GROUP_INFO = DOMAIN + '/wxw/chat/getgroupinfo'//15 获取聊天群基本信息
const URL_CHAT_GET_CUSTOMERS = DOMAIN + '/wxw/chat/getcustomers' //19 获取账号客户列表
const URL_CHAT_GET_CUSTOMERS_SELECT_ALL = DOMAIN + '/wxw/chat/getcustomers/selectAll'
const URL_CHAT_GET_WORK_MATES = DOMAIN + '/wxw/chat/getworkmates' //20 获取账号企业成员列表
const URL_CHAT_CREATE_CHAT_ROOM = DOMAIN + '/wxw/chat/createchatroom' //发起群聊接口
const URL_CHAT_EDIT_GROUP_ANNOUNCE = DOMAIN + '/wxw/chat/editgroupannounce' //编辑群公告
const URL_CHAT_ADD_GROUP_TAG = DOMAIN + '/wxw/chat/addgroupgtag' //18 添加聊天群标签
const URL_CHAT_DEL_GROUP_TAG = DOMAIN + '/wxw/chat/delgroupgtag' //17 删除聊天群标签
const URL_CHAT_INVITE_TO_GROUP = DOMAIN + '/wxw/chat/invitetogroup' //21 邀请客户/企业成员入群
const URL_CHAT_REMOVE_FROM_GROUP = DOMAIN + '/wxw/chat/removefromgroup' //22 群聊踢出客户/企业成员


const URL_CHAT_GET_CUSTOMER_INFO = DOMAIN + '/wxw/chat/getcustomerinfo' //30 获取私聊客户基本信息
const URL_CHAT_EDIT_CUSTOMER_REMARK = DOMAIN + '/wxw/chat/editcustomerremark' //31 编辑聊天客户备注
const URL_CHAT_EDIT_CUSTOMER_DESC = DOMAIN + '/wxw/chat/editcustomerdesc' //32 编辑聊天客户描述
const URL_CHAT_ADD_CUSTOMER_TAG = DOMAIN + '/wxw/chat/addcustomertag' //编辑客户资料的标签
const URL_CHAT_DEL_CUSTOMER_TAG = DOMAIN + '/wxw/chat/delcustomertag' //33 删除聊天客户标签

const URL_CHAT_EDIT_CUSTOMER_NEW_ADD = DOMAIN + '/wxw/chat/editcustomer'  //编辑聊天客户

const URL_CHAT_POST_CHAT = DOMAIN + '/wxw/chat/postchat' //20.1 发起聊天
const URL_CHAT_RADIO = DOMAIN + '/wxw/chat/chatRadio' //关闭当前的联系人

const URL_CHAT_ACCOUNT_TOP_FLAG = DOMAIN + '/wxw/chat/accounttopflag' //置顶联系人


const URL_CHAT_GET_ROOM_MEMBER = DOMAIN + '/wxw/chat/groupMember' //群成员

const URL_CHAT_WX_LOGIN = DOMAIN + '/wxw/seat/accountlogin' //账号自动登录席位
const URL_CHAT_WX_LOGIN_STATUS = DOMAIN + '/wxw/seat/accountloginstatus' //账号自动登录状态
const URL_LOGIN_SCAN_RESULT = DOMAIN + '/wxw/seat/loginScanResult'
const URL_LOGIN_VERIFY = DOMAIN + '/wxw/seat/loginVerify'
const URL_CHAT_MSG_SEARCH = DOMAIN + '/wxw/chat/msg/globalsearch'//04 全局搜索

//聊天配置
const URL_CHAT_SETTINGS_LIST = DOMAIN + '/wxw/chat/accountPage'  //聊天配置账号列表
const URL_CHAT_SETTINGS_RADIO = DOMAIN + '/wxw/chat/chatRadio'  //聊天配置开启聊天

//账号管理新增（席位管理变更）
const URL_CLOUD_HOME_ACCOUNT_OVERVIEW = DOMAIN + '/wxw/account/overview' //账号概览
const URL_CLOUD_HOME_ACCOUNT_LIST = DOMAIN + '/wxw/account/accountlist' //账号列表
const URL_CLOUD_HOME_GROUP_NAME_LIST = DOMAIN + '/wxw/account/group/selectlist' //账号分组下拉列表
const URL_CLOUD_HOME_GROUP_LIST = DOMAIN + '/wxw/account/group/list' //账号分组列表
const URL_CLOUD_HOME_GROUP_ADD = DOMAIN + '/wxw/account/group/add' //账号分组新建
const URL_CLOUD_HOME_GROUP_EDIT = DOMAIN + '/wxw/account/group/edit' //账号分组编辑
const URL_CLOUD_HOME_GROUP_DELETE = DOMAIN + '/wxw/account/group/del' //账号分组删除
const URL_CLOUD_HOME_GROUP_SET_MORE = DOMAIN + '/wxw/account/groupaccount' //批量账号分组
const URL_CLOUD_HOME_ACCOUNT_QUIT = DOMAIN + '/wxw/account/quit' //账号下线
const URL_CLOUD_HOME_ACCOUNT_DELETE = DOMAIN + '/wxw/account/delaccount' //账号删除
const URL_CLOUD_HOME_ACCOUNT_ADD = DOMAIN + '/wxw/account/addaccount' //添加账号


//高级拉群
const URL_WXW_PULL_GROUP_LIST = DOMAIN + '/wxw/pullgroup/list' //04 任务列表
const URL_WXW_PULL_GROUP_GET_CUSTOMERS = DOMAIN + '/wxw/pullgroup/getcustomers' //13 获取客户信息
const URL_WXW_PULL_GROUP_CREATE = DOMAIN + '/wxw/pullgroup/create' //创建任务
const URL_WXW_PULL_GROUP_DETAIL = DOMAIN + '/wxw/pullgroup/detail' //任务详情
const URL_WXW_PULL_GROUP_EDIT = DOMAIN + '/wxw/pullgroup/edit' //编辑任务
const URL_WXW_PULL_GROUP_DELETE = DOMAIN + '/wxw/pullgroup/delete' //删除任务
const URL_WXW_PULL_GROUP_STOP = DOMAIN + '/wxw/pullgroup/stop'//停止任务
const URL_WXW_PULL_GROUP_START = DOMAIN + '/wxw/pullgroup/start'//开启任务
const URL_WXW_PULL_GROUP_COUNT_NUM = DOMAIN + '/wxw/pullgroup/countNum' //统计人数
const URL_WXW_PULL_GROUP_MENU_LIST = DOMAIN + '/wxw/pullgroup/menulist' //活动下拉
const URL_WXW_PULL_GROUP_TASK_DETAIL_BASIN_INFO = DOMAIN + '/wxw/pullgroup/taskdetail/basicInfo' //入群详情基本信息
const URL_WXW_PULL_GROUP_ENTER_CUSOTMER = DOMAIN + '/wxw/pullgroup/enterCusotmer' //入群客户
const URL_WXW_PULL_GROUP_ROOM_LIST = DOMAIN + '/wxw/pullgroup/roomList' //已建群聊的列表

const URL_GROUP_MANAGER_ACCOUNT_ROOMS = DOMAIN + '/wxw/groupmanager/accountRooms'
const URL_GROUP_MANAGER_ACCOUNT_ROOMS_SELECT_ALL = DOMAIN + '/wxw/groupmanager/accountRooms/selectAll'
//群公告
const URL_GROUP_CHAT_NOTICE_LIST = DOMAIN + '/wxw/roomnotice/tasklist' //任务列表
const URL_GROUP_CHAT_NOTICE_NAMELIST = DOMAIN + '/wxw/roomnotice/taskname' //名称下拉列表
const URL_GROUP_CHAT_NOTICE_REPORT_OVERVIEW = DOMAIN + '/wxw/roomnotice/taskoverview' //任务概览
const URL_GROUP_CHAT_NOTICE_REPORT_LIST = DOMAIN + '/wxw/roomnotice/taskrecord' //数据统计列表
const URL_GROUP_CHAT_NOTICE_DEL_TASK = DOMAIN + '/wxw/roomnotice/deltask' //删除任务
const URL_GROUP_CHAT_NOTICE_OPEN_TASK = DOMAIN + '/wxw/roomnotice/starttask' //开启任务
const URL_GROUP_CHAT_NOTICE_STOP_TASK = DOMAIN + '/wxw/roomnotice/stoptask' //停止任务
const URL_GROUP_CHAT_NOTICE_CREATE_TASK = DOMAIN + '/wxw/roomnotice/create' //创建任务
const URL_GROUP_CHAT_NOTICE_TASK_DETAIL = DOMAIN + '/wxw/roomnotice/detail' //任务详情
const URL_GROUP_CHAT_NOTICE_TASK_EDIT = DOMAIN + '/wxw/roomnotice/edit' //编辑任务

//聊天 发送好友验证
const URL_CHAT_SEND_ADD_FRIEND = DOMAIN + '/wxw/chat/addFriend'
const URL_CHAT_SEND_ADD_FRIEND_INFO = DOMAIN + '/wxw/chat/accountBasicInfo'

//语音识别
const URL_CHAT_AUDIO_TO_TEXT = DOMAIN + '/wxw/chat/translate'
const URL_CHAT_AUDIO_TO_LISTEN = DOMAIN + '/wxw/chat/listenAudio' //语音标记已读

//话术库
const URL_CHAT_LIB_GROUP_CREATE = DOMAIN + '/wxw/chat/chatlib/group/create' //00 话术分组创建
const URL_CHAT_LIB_GROUP_LIST = DOMAIN + '/wxw/chat/chatlib/group/list' //01 话术分组列表
const URL_CHAT_LIB_GROUP_EDIT = DOMAIN + '/wxw/chat/chatlib/group/edit' // 02 话术分组修改名称
const URL_CHAT_LIB_GROUP_DEL = DOMAIN + '/wxw/chat/chatlib/group/del' //03 话术分组删除
const URL_CHAT_LIB_LIST = DOMAIN + '/wxw/chat/chatlib/list' //04 话术列表
const URL_CHAT_LIB_CREATE = DOMAIN + '/wxw/chat/chatlib/create' // 05 话术创建
const URL_CHAT_LIB_CONTENT_LIST = DOMAIN + '/wxw/chat/chatlib/contentlist' //06 话术列表聊天栏
const URL_CHAT_LIB_DETAIL = DOMAIN + '/wxw/chat/chatlib/detail' //07 话术详情
const URL_CHAT_LIB_EDIT = DOMAIN + '/wxw/chat/chatlib/edit' //08 话术编辑
const URL_CHAT_LIB_DEL = DOMAIN + '/wxw/chat/chatlib/del' //09 话术删除
const URL_CHAT_LIB_SWAPORDER = DOMAIN + '/wxw/chat/chatlib/swaporder' //10 交换话术顺序
const URL_CHAT_LIB_SEND = DOMAIN + '/wxw/chat/chatlib/send' //11 发送话术


//素材库
const URL_CUSTOMER_MEDIA_GROUPS_LIST = DOMAIN + '/wxw/media/groups/list' //02素材分组列表
const URL_CUSTOMER_MEDIA_GROUPS_RENAME = DOMAIN + '/wxw/media/groups/rename' //03 素材分组编辑
const URL_CUSTOMER_MEDIA_GROUPS_CREATE = DOMAIN + '/wxw/media/groups/create' //01 素材分组创建
const URL_CUSTOMER_MEDIA_GROUPS_DEL = DOMAIN + '/wxw/media/groups/del' //04 素材分组删除
const URL_CUSTOMER_MEDIA_CREATE = DOMAIN + '/wxw/media/create' //05 素材创建
const URL_CUSTOMER_MEDIA_DETAIL = DOMAIN + '/wxw/media/detail' //06 素材详情
const URL_CUSTOMER_MEDIA_LIST = DOMAIN + '/wxw/media/list' //06 素材创建列表
const URL_CUSTOMER_MEDIA_EDIT = DOMAIN + '/wxw/media/edit' //素材编辑
const URL_CUSTOMER_MEDIA_DEL = DOMAIN + '/wxw/media/del' //08 素材删除
const URL_CUSTOMER_MEDIA_PHONE_UPLOAD_RADIO = DOMAIN + '/wxw/media/phoneupload/radio' //09 素材创建手机端上传开关
const URL_CUSTOMER_MEDIA_PHONE_UPLOAD_STATUS = DOMAIN + '/wxw/media/phoneupload/status' //10 素材创建手机端上传状态


//群活码
const URL_GROUP_CHAT_LIVECODE_LIST = DOMAIN + '/wxw/roomlivecode/codelist/query' //群活码列表查询
const URL_GROUP_CHAT_LIVECODE_CREATE = DOMAIN + '/wxw/roomlivecode/create' //群活码创建
const URL_GROUP_CHAT_LIVECODE_DETAIL = DOMAIN + '/wxw/roomlivecode/detail' //群活码详情
const URL_GROUP_CHAT_LIVECODE_EDIT = DOMAIN + '/wxw/roomlivecode/edit' //群活码编辑
const URL_GROUP_CHAT_LIVECODE_DELETE = DOMAIN + '/wxw/roomlivecode/delete' //删除群活码
const URL_GROUP_CHAT_LIVECODE_MODIFY_STATUS = DOMAIN + '/wxw/roomlivecode/modifystatus' //暂停/开启群活码

const URL_GROUP_CHAT_LIVECODE_CODEGROUP_LIST = DOMAIN + '/wxw/roomlivecode/codegrouplist' //群活码分组下拉列表
const URL_GROUP_CHAT_LIVECODE_ROOMLIST = DOMAIN + '/wxw/roomlivecode/roomlist/query' //群聊列表查询
const URL_GROUP_CHAT_LIVECODE_ROOM_OPEN_OR_STOP = DOMAIN + '/wxw/roomlivecode/roomshowstatus' //停止/开启群聊分配
const URL_GROUP_CHAT_LIVECODE_ROOM_ORDER = DOMAIN + '/wxw/roomlivecode/roomorder' //调整群聊顺序

const URL_GROUP_CHANT_LIVECODE_REPORT_SCANDATA = DOMAIN + '/wxw/roomlivecode/datastats/scandata' //扫码数据
const URL_GROUP_CHANT_LIVECODE_REPORT_LIST = DOMAIN + '/wxw/roomlivecode/datastats/details' //数据明细
const URL_GROUP_CHANT_LIVECODE_REPORT_LINE = DOMAIN + '/wxw/roomlivecode/datastats/trenddata' //数据走势
const URL_GROUP_CHANT_LIVECODE_REPORT_AREA = DOMAIN + '/wxw/roomlivecode/datastats/areadata' //区域数据

//入群欢迎语
const URL_GROUP_CHAT_ROOMWELMSG_LIST = DOMAIN + '/wxw/roomwelmsg/tasklist/query' //入群欢迎语任务列表查询
const URL_GROUP_CHAT_ROOMWELMSG_DELETE = DOMAIN + '/wxw/roomwelmsg/delete' //删除入群欢迎语
const URL_GROUP_CHAT_ROOMWELMSG_NAMELIST = DOMAIN + '/wxw/roomwelmsg/taskselectlist' //获取欢迎语任务下拉列表数据
const URL_GROUP_CHAT_ROOMWELMSG_CREATE = DOMAIN + '/wxw/roomwelmsg/create' //创建入群欢迎语任务
const URL_GROUP_CHAT_ROOMWELMSG_EDIT = DOMAIN + '/wxw/roomwelmsg/edit' //编辑入群欢迎语任务
const URL_GROUP_CHAT_ROOMWELMSG_DETAIL = DOMAIN + '/wxw/roomwelmsg/detail' //获取入群欢迎语任务详情
const URL_GROUP_CHAT_ROOMWELMSG_MODIFY_STATUS = DOMAIN + '/wxw/roomwelmsg/modifystatus' //开启/关闭入群欢迎语任务
const URL_GROUP_CHAT_ROOMWELMSG_REPORT = DOMAIN + '/wxw/roomwelmsg/senddata' //入群欢迎语任务数据

//最近联系人
const URL_IM_CHAT_RECENT_LIST = DOMAIN + '/wxw/chat/msg/contact/recent'
const URL_IM_CHAT_CONTACT_SEARCH = DOMAIN + '/wxw/chat/msg/contact/search'

//聊天记录
const URL_IM_CHAT_CONTACT_CONTENT_LIST = DOMAIN + '/wxw/chat/msg/chat/contentlist'

//关键词拉群
const URL_GROUP_CHAT_KWPULL_GROUP_LIST = DOMAIN + '/wxw/app/keywordgroup/tasklist'
const URL_GROUP_CHAT_KWPULL_GROUP_CREATE = DOMAIN + '/wxw/app/keywordgroup/create'
const URL_GROUP_CHAT_KWPULL_GROUP_EDIT = DOMAIN + '/wxw/app/keywordgroup/edit'
const URL_GROUP_CHAT_KWPULL_GROUP_DETAIL = DOMAIN + '/wxw/app/keywordgroup/detail'
const URL_GROUP_CHAT_KWPULL_GROUP_DELETE = DOMAIN + '/wxw/app/keywordgroup/del'
const URL_GROUP_CHAT_KWPULL_GROUP_CLOSE = DOMAIN + '/wxw/app/keywordgroup/close'
const URL_GROUP_CHAT_KWPULL_GROUP_OPEN = DOMAIN + '/wxw/app/keywordgroup/open'
const URL_GROUP_CHAT_KWPULL_GROUP_NAMELIST = DOMAIN + '/wxw/app/keywordgroup/tasknamelist'
const URL_GROUP_CHAT_KWPULL_GROUP_STATS = DOMAIN + '/wxw/app/keywordgroup/statsdata'
const URL_GROUP_CHAT_KWPULL_GROUP_REPORT_LIST = DOMAIN + '/wxw/app/keywordgroup/customerlist'

//获取用户是否添加客服
const URL_GET_USER_ADD_CUST_STATUS = DOMAIN + '/user/customerserviceflag'

//单向好友
const URL_ONE_WAY_FRIEND_LIST = DOMAIN + '/wxw/account/friends/accountlist'
const URL_ONE_WAY_FRIEND_LIST_OPEN = DOMAIN + '/wxw/account/friends/opencheck'
const URL_ONE_WAY_FRIEND_LIST_CLOSE = DOMAIN + '/wxw/account/friends/closecheck'
const URL_ONE_WAY_FRIEND_DELETE = DOMAIN + '/wxw/account/friends/del'
const URL_ONE_WAY_FRIEND_REPORT_STATS = DOMAIN + '/wxw/account/friends/overview'
const URL_ONE_WAY_FRIEND_REPORT_CONFIG = DOMAIN + '/wxw/account/friends/config'
const URL_ONE_WAY_FRIEND_REPORT_LIST = DOMAIN + '/wxw/account/friends/friendlist'
const URL_ONE_WAY_FRIEND_REPORT_GET_CONFIG = DOMAIN + '/wxw/account/friends/getconfig'

// 获取自动通过好友请求设置
const URL_GET_AUTO_FRIEND_CONFIG = DOMAIN + '/wxw/account/newfriendconfig/detail'
const URL_SET_AUTO_FRIEND_CONFIG = DOMAIN + '/wxw/account/newfriendconfig/edit'

//消息添加到素材库
const URL_IM_CHAT_ADD_MSG_TO_LIB = DOMAIN + '/wxw/chat/addToMediaLib'
//名片加好友
const URL_IM_CHAT_ADD_FRIEND_FROM_CARD = DOMAIN + '/wxw/chat/addCardFriend'
//群聊下加好友
const URL_IM_CHAT_IS_FRIEND_FROM_ROOM = DOMAIN + '/wxw/chat/isFriend'//判断群成员是否为好友
const URL_IM_CHAT_ADD_FRIEND_FROM_ROOM = DOMAIN + '/wxw/chat/addFriendByGroup'//添加群成员好友

//cloud客户管理
const URL_CLOUD_CUST_OPERATION_MAMAGE_LIST = DOMAIN + '/wxw/customer/list'
const URL_CLOUD_CUST_OPERATION_MAMAGE_DETAIL = DOMAIN + '/wxw/customer/detail'
const URL_CLOUD_CUST_OPERATION_GROUP_LIST = DOMAIN + '/wxw/customer/grouplist'
const URL_CLOUD_CUST_OPERATION_BAT_TAG = DOMAIN + '/wxw/customer/battag'
const URL_CLOUD_CUST_OPERATION_BAT_DEL = DOMAIN + '/wxw/customer/batdeltag'
const URL_CLOUD_CUST_OPERATION_BAT_REAKARK = DOMAIN + '/wxw/customer/batremark'
const URL_CLOUD_CUST_OPERATION_GET_COUNT = DOMAIN + '/wxw/customer/count'


//子账户
const URL_SUB_ACCOUNT_ROLE_LIST = DOMAIN + '/sub_account/role/list' //获取角色列表
const URL_SUB_ACCOUNT_ROLE_CREATE = DOMAIN + '/sub_account/role/create'//创建角色
const URL_SUB_ACCOUNT_ROLE_EDIT_NAME = DOMAIN + '/sub_account/role/edit_name' //编辑角色
const URL_SUB_ACCOUNT_ROLE_DELETE = DOMAIN + '/sub_account/role/delete' //删除角色
const URL_SUB_ACCOUNT_ROLE_CONF = DOMAIN + '/sub_account/role/conf'//获取角色的配置
const URL_SUB_ACCOUNT_ROLE_EDIT_CONF = DOMAIN + '/sub_account/role/edit_conf' //编辑角色配置

//子账号分组
const URL_SUB_ACCOUNT_GROUP_LIST = DOMAIN + '/sub_account/group/list' //子账号分组列表
const URL_SUB_ACCOUNT_CREATE_GROUP = DOMAIN + '/sub_account/group/create' //创建子账号分组
const URL_SUB_ACCOUNT_DELETE_GROUP = DOMAIN + '/sub_account/group/delete' //子账号分组列表
const URL_SUB_ACCOUNT_EDIT_GROUP = DOMAIN + '/sub_account/group/edit' //子账号分组列表

//子账号列表
const URL_SUB_ACCOUNT_LIST = DOMAIN + '/sub_account/list' //子账号列表
const URL_SUB_ACCOUNT_CREATE = DOMAIN + '/sub_account/create' //创建子账号
const URL_SUB_ACCOUNT_EDIT = DOMAIN + '/sub_account/edit' //编辑子账号
const URL_SUB_ACCOUNT_DELETE = DOMAIN + '/sub_account/delete' //删除子账号
const URL_SUB_ACCOUNT_GET_DETAIL = DOMAIN + '/sub_account/detail' //获取子账号详情
const URL_SUB_ACCOUNT_BATCH_GROUPING = DOMAIN + '/sub_account/batch_grouping' //批量分组
const URL_SUB_ACCOUNT_GROUP_SELECT_LIST = DOMAIN + '/sub_account/group/selectlist' //分组下拉

//企微账号下拉
const URL_CLOUD_QW_ACCOUNT_SELECT_LIST = DOMAIN + '/wxw/account/selectlist' //获取账号下拉列表

//聊天消息发送状态
const URL_IM_CHAT_MEG_SEND_STATUS = DOMAIN + '/wxw/chat/getMsgSendStatus' //获取聚合聊天消息发送状态

//获取群聊成员基本信息接口，用户鼠标左击展示信息
const URL_IM_CHAT_GROUP_MEMBER_INFO = DOMAIN + '/wxw/chat/getGroupMemberInfo'

//获取同步状态
const URL_GET_GROUP_MANAGE_SYNC_STATUS = DOMAIN + '/wxw/groupmanager/syncGroupStatus' //获取同步群聊列表状态
const URL_GET_CUSTOMER_SYNC_STATUS = DOMAIN + '/wxw/customer/syncAllCustomerStatus' //获取同步所有客户的状态
const URL_CUSTOMER_SYNC_ALL_CUSTOMER = DOMAIN + '/wxw/customer/syncAllCustomer' //同步所有客户

class CloudApi {

    /**
     * 同步所有客户
     * @param success
     * @param error
     */
    static syncAllCustomer(success, error) {
        doPost(URL_CUSTOMER_SYNC_ALL_CUSTOMER, 'json', {}, success, error)
    }

    /**
     *获取同步所有客户的状态
     * @param success
     * @param error
     */
    static getCustomerSyncStatus(success, error) {
        doGet(URL_GET_CUSTOMER_SYNC_STATUS, success, error)
    }

    /**
     * 获取同步群聊列表状态
     * @param success
     * @param error
     */
    static getGroupManageSyncStatus(success, error) {
        doGet(URL_GET_GROUP_MANAGE_SYNC_STATUS, success, error)
    }

    /**
     * 获取群聊成员基本信息接口，用户鼠标左击展示信息
     * @param bodyData
     * @param success
     * @param error
     */
    static getImChatGroupMemberInfo(bodyData, success, error) {
        doPost(URL_IM_CHAT_GROUP_MEMBER_INFO, 'json', bodyData, success, error)
    }

    /**
     * 获取聚合聊天消息发送状态
     * @param queryParam
     * @param success
     * @param error
     */
    static getImChatMsgSendStatus(queryParam, success, error) {
        let query = `?wxid=${queryParam.wxid}&chatWxid=${queryParam.chatWxid}&msgSendId=${queryParam.msgSendId}`
        doGet(URL_IM_CHAT_MEG_SEND_STATUS + query, success, error)
    }

    /**
     * 企微账号下拉
     * @param success
     * @param error
     */
    static getQWAccountSelectList(success, error) {
        doGet(URL_CLOUD_QW_ACCOUNT_SELECT_LIST, success, error)
    }

    /**
     * 子账号 分组下拉
     * @param success
     * @param error
     */
    static getSubGroupSelectList(success, error) {
        doGet(URL_SUB_ACCOUNT_GROUP_SELECT_LIST, success, error)
    }

    /**
     * 子账号批量分组
     * @param bodyData
     * @param success
     * @param error
     */
    static subAccountBatchGrouping(bodyData, success, error) {
        doPost(URL_SUB_ACCOUNT_BATCH_GROUPING, 'json', bodyData, success, error)
    }

    /**
     * 删除子账号
     * @param bodyData
     * @param success
     * @param error
     */
    static deleteSubAccount(bodyData, success, error) {
        doPost(URL_SUB_ACCOUNT_DELETE, 'json', bodyData, success, error)
    }

    /**
     * 获取子账号详情
     * @param bodyData
     * @param success
     * @param error
     */
    static getSubAccountDetail(accountId, success, error) {
        doGet(URL_SUB_ACCOUNT_GET_DETAIL + `?accountId=${accountId}`, success, error)
    }

    /**
     * 编辑子账号
     * @param bodyData
     * @param success
     * @param error
     */
    static editSubAccount(bodyData, success, error) {
        doPost(URL_SUB_ACCOUNT_EDIT, 'json', bodyData, success, error)
    }

    /**
     * 创建子账号
     * @param bodyData
     * @param success
     * @param error
     */
    static createSubAccount(bodyData, success, error) {
        doPost(URL_SUB_ACCOUNT_CREATE, 'json', bodyData, success, error)
    }

    /**
     *子账号列表
     * @param queryParam
     * @param success
     * @param error
     */
    static getSubAccList(queryParam, success, error) {
        let query = `?pageNum=${queryParam.pageNum}&pageSize=${queryParam.pageSize}&name=${queryParam.name}&groupId=${queryParam.groupId}`
        doGet(URL_SUB_ACCOUNT_LIST + query, success, error)
    }

    /**
     * 修改子账号分组
     * @param bodyData
     * @param success
     * @param error
     */
    static editSubAccGroup(bodyData, success, error) {
        doPost(URL_SUB_ACCOUNT_EDIT_GROUP, 'json', bodyData, success, error)
    }

    /**
     * 删除子账号分组
     * @param bodyData
     * @param success
     * @param error
     */
    static deleteSubAccGroup(bodyData, success, error) {
        doPost(URL_SUB_ACCOUNT_DELETE_GROUP, 'json', bodyData, success, error)
    }

    /**
     *
     * @param bodyData
     * @param success
     * @param error
     */
    static createSubAccGroup(bodyData, success, error) {
        doPost(URL_SUB_ACCOUNT_CREATE_GROUP, 'json', bodyData, success, error)
    }

    /**
     * 子账号分组列表
     * @param success
     * @param error
     */
    static getSubAccGroupList(success, error) {
        doGet(URL_SUB_ACCOUNT_GROUP_LIST, success, error)
    }

    /**
     *  判断是否为好友
     * @param bodyData
     * @param success
     * @param error
     */
    static isFriendFromRoom(bodyData, success, error) {
        doPost(URL_IM_CHAT_IS_FRIEND_FROM_ROOM, 'json', bodyData, success, error)
    }

    /**
     * 群成员加好友
     * @param bodyData
     * @param success
     * @param error
     */
    static addFriendFromRoom(bodyData, success, error) {
        doPost(URL_IM_CHAT_ADD_FRIEND_FROM_ROOM, 'json', bodyData, success, error)
    }

    /**
     * 名片加好友
     * @param bodyData
     * @param success
     * @param error
     */
    static addFriendFromCard(bodyData, success, error) {
        doPost(URL_IM_CHAT_ADD_FRIEND_FROM_CARD, 'json', bodyData, success, error)
    }

    /**
     * 消息添加到素材库
     * @param bodyData
     * @param success
     * @param error
     */
    static addImChatMsgToLib(bodyData, success, error) {
        doPost(URL_IM_CHAT_ADD_MSG_TO_LIB, 'json', bodyData, success, error)
    }

    /**
     * 客户管理 客户计数
     * @param success
     * @param error
     */
    static getCloudCustomerOperationCustCount(success, error) {
        doGet(URL_CLOUD_CUST_OPERATION_GET_COUNT, success, error)
    }

    /**
     * cloud客户管理 批量备注
     * @param bodyData
     * @param success
     * @param error
     */
    static getCloudCustomerOperationBatRemark(bodyData, success, error) {
        doPost(URL_CLOUD_CUST_OPERATION_BAT_REAKARK, 'json', bodyData, success, error)
    }

    /**
     * cloud客户管理 批删除标签
     * @param bodyData
     * @param success
     * @param error
     */
    static getCloudCustomerOperationBatDel(bodyData, success, error) {
        doPost(URL_CLOUD_CUST_OPERATION_BAT_DEL, 'json', bodyData, success, error)
    }

    /**
     * cloud客户管理 批量打标签
     * @param bodyData
     * @param success
     * @param error
     */
    static getCloudCustomerOperationBattag(bodyData, success, error) {
        doPost(URL_CLOUD_CUST_OPERATION_BAT_TAG, 'json', bodyData, success, error)
    }

    /**
     * 客户群聊列表
     * @param queryParam
     * @param bodyData
     * @param success
     * @param error
     */
    static getCloudCustomerOperationGroupList(queryParam, bodyData, success, error) {
        let query = `?pageSize=${queryParam.pageSize}&pageNum=${queryParam.pageNum}`
        doPost(URL_CLOUD_CUST_OPERATION_GROUP_LIST + query, 'json', bodyData, success, error)
    }

    /**
     * 客户详情
     * @param friendId
     * @param success
     * @param error
     */
    static getCloudCustomerManageDetail(friendId, success, error) {
        doGet(URL_CLOUD_CUST_OPERATION_MAMAGE_DETAIL + `?friendId=${friendId}`, success, error)
    }

    /**
     *  客户管理列表
     * @param bodyData
     * @param success
     * @param error
     */
    static getCloudCustomerManageList(queryParam, bodyData, success, error) {
        let query = `?pageSize=${queryParam.pageSize}&pageNum=${queryParam.pageNum}`
        doPost(URL_CLOUD_CUST_OPERATION_MAMAGE_LIST + query, 'json', bodyData, success, error)
    }

    /**
     * 编辑自动通过好友请求设置
     * @param bodyData
     * @param success
     * @param error
     */
    static setAutoFriendConfig(bodyData, success, error) {
        doPost(URL_SET_AUTO_FRIEND_CONFIG, 'json', bodyData, success, error)
    }

    /**
     * 获取自动通过好友请求设置
     * @param success
     * @param error
     */
    static getAutoFriendConfig(success, error) {
        doGet(URL_GET_AUTO_FRIEND_CONFIG, success, error)
    }

    /**
     *  聊天内容列表
     * @param bodyData
     * @param success
     * @param error
     */
    static getChatRecordList(queryParam, bodyData, success, error) {
        let query = `?pageSize=${queryParam.pageSize}&pageNum=${queryParam.pageNum}`
        doPost(URL_IM_CHAT_CONTACT_CONTENT_LIST + query, 'json', bodyData, success, error)
    }

    /**
     *获取用户是否添加客服
     * @param success
     * @param error
     */
    static getUserAddCustStatus(success, error) {
        doGet(URL_GET_USER_ADD_CUST_STATUS, success, error)
    }

    /**
     * 关键字拉群活动关
     * @param bodyData
     * @param success
     * @param error
     */
    static closeKWPullGroup(bodyData, success, error) {
        doPost(URL_GROUP_CHAT_KWPULL_GROUP_CLOSE, 'json', bodyData, success, error)
    }

    /**
     * 关键字拉群活动开
     * @param bodyData
     * @param success
     * @param error
     */
    static openKWPullGroup(bodyData, success, error) {
        doPost(URL_GROUP_CHAT_KWPULL_GROUP_OPEN, 'json', bodyData, success, error)
    }

    /**
     * 键字拉群 参与客户列表
     * @param queryParam
     * @param bodyData
     * @param success
     * @param error
     */
    static getKWPullGroupReportList(queryParam, bodyData, success, error) {
        let query = `?pageSize=${queryParam.pageSize}&pageNum=${queryParam.pageNum}`
        doPost(URL_GROUP_CHAT_KWPULL_GROUP_REPORT_LIST + query, 'json', bodyData, success, error)
    }

    /**
     *关键字拉群活动活动数据统计
     * @param id
     * @param success
     * @param error
     */
    static getKWPullGroupStats(id, success, error) {
        doGet(URL_GROUP_CHAT_KWPULL_GROUP_STATS + `?id=${id}`, success, error)
    }

    /**
     *获取关键字拉群活动列表
     * @param success
     * @param error
     */
    static getKWPullGroupNameList(success, error) {
        doGet(URL_GROUP_CHAT_KWPULL_GROUP_NAMELIST, success, error)
    }

    /**
     * 删除关键词拉群
     * @param id
     * @param success
     * @param error
     */
    static deleteKWPullGroup(id, success, error) {
        doGet(URL_GROUP_CHAT_KWPULL_GROUP_DELETE + `?id=${id}`, success, error)
    }

    /**
     * 关键词拉群详情
     * @param id
     * @param success
     * @param error
     */
    static getKWPullGroupDetail(id, success, error) {
        doGet(URL_GROUP_CHAT_KWPULL_GROUP_DETAIL + `?id=${id}`, success, error)
    }

    /**
     * 编辑关键词拉群
     * @param bodyData
     * @param success
     * @param error
     */
    static editKWPullGroup(bodyData, success, error) {
        doPost(URL_GROUP_CHAT_KWPULL_GROUP_EDIT, 'json', bodyData, success, error)
    }

    /**
     * 创建关键词拉群
     * @param bodyData
     * @param success
     * @param error
     */
    static createKWPullGroup(bodyData, success, error) {
        doPost(URL_GROUP_CHAT_KWPULL_GROUP_CREATE, 'json', bodyData, success, error)
    }

    /**
     * 关键字拉群活动列表
     * @param queryParam
     * @param bodyData
     * @param success
     * @param error
     */
    static getKWPullGroupList(queryParam, bodyData, success, error) {
        let query = `?pageSize=${queryParam.pageSize}&pageNum=${queryParam.pageNum}`
        doPost(URL_GROUP_CHAT_KWPULL_GROUP_LIST + query, 'json', bodyData, success, error)
    }

    /**
     * 单向好友 获取自定义参数
     * @param success
     * @param error
     */
    static getOneWayFriendConfig(success, error) {
        doGet(URL_ONE_WAY_FRIEND_REPORT_GET_CONFIG, success, error)
    }

    /**
     * 单向好友 好友列表
     * @param queryParam
     * @param bodyData
     * @param success
     * @param error
     */
    static getOneWayFriendReportList(queryParam, bodyData, success, error) {
        let query = `?pageSize=${queryParam.pageSize}&pageNum=${queryParam.pageNum}`
        doPost(URL_ONE_WAY_FRIEND_REPORT_LIST + query, 'json', bodyData, success, error)
    }

    /**
     * 关闭单向好友自动检测
     * @param bodyData
     * @param success
     * @param error
     */
    static closeOneWayFriend(bodyData, success, error) {
        doPost(URL_ONE_WAY_FRIEND_LIST_CLOSE, 'json', bodyData, success, error)
    }

    /**
     * 开启单向好友自动检测
     * @param bodyData
     * @param success
     * @param error
     */
    static openOneWayFriend(bodyData, success, error) {
        doPost(URL_ONE_WAY_FRIEND_LIST_OPEN, 'json', bodyData, success, error)
    }

    /**
     * 单向好友 参数自定义
     * @param bodyData
     * @param success
     * @param error
     */
    static doOneWayFriendConfig(bodyData, success, error) {
        doPost(URL_ONE_WAY_FRIEND_REPORT_CONFIG, 'json', bodyData, success, error)
    }

    /**
     * 单向好友 数据概览
     * @param success
     * @param error
     */
    static getOneWayFriendStats(accountId, success, error) {
        doGet(URL_ONE_WAY_FRIEND_REPORT_STATS + `?accountId=${accountId}`, success, error)
    }

    /**
     * 单向好友 删除好友
     * @param bodyData
     * @param success
     * @param error
     */
    static deleteOneWayFriend(bodyData, success, error) {
        doPost(URL_ONE_WAY_FRIEND_DELETE, 'json', bodyData, success, error)
    }

    /**
     * 单向好友 账号列表
     * @param queryParam
     * @param success
     * @param error
     */
    static getOneWayFriendList(queryParam, success, error) {
        let query = `?name=${queryParam.name}&pageSize=${queryParam.pageSize}&pageNum=${queryParam.pageNum}`
        doGet(URL_ONE_WAY_FRIEND_LIST + query, success, error)
    }

    /**
     *获取用户是否添加客服
     * @param success
     * @param error
     */
    static getUserAddCustStatus(success, error) {
        doGet(URL_GET_USER_ADD_CUST_STATUS, success, error)
    }

    /**
     * 开启/关闭新好友运营任务
     * @param bodyData
     * @param success
     * @param error
     */
    static switchRemarkStatus(bodyData, success, error) {
        doPost(URL_ACCOUNT_REMARK_MODIFY_STATUS, 'json', bodyData, success, error)
    }

    /**
     *  搜索联系人
     * @param keyword
     * @param success
     * @param error
     */
    static getImContactSearchList(queryParam, success, error) {
        let query = `?keyword=${queryParam.keyword}&accountId=${queryParam.accountId}`
        doGet(URL_IM_CHAT_CONTACT_SEARCH + query, success, error)
    }

    /**
     * 最近联系人
     * @param success
     * @param error
     */
    static getImChatRecentList(accountId, success, error) {
        doGet(URL_IM_CHAT_RECENT_LIST + `?accountId=${accountId}`, success, error)
    }

    /**
     * 入群欢迎语任务数据
     * @param queryParam
     * @param success
     * @param error
     */
    static getRoomWelMsgReportList(queryParam, bodyData, success, error) {
        let query = `?pageSize=${queryParam.pageSize}&pageNum=${queryParam.pageNum}`
        doPost(URL_GROUP_CHAT_ROOMWELMSG_REPORT + query, 'json', bodyData, success, error)
    }

    /**
     * //开启/关闭入群欢迎语任务
     * @param bodyData
     * @param success
     * @param error
     */
    static switchRoomWelMsgStatus(bodyData, success, error) {
        doPost(URL_GROUP_CHAT_ROOMWELMSG_MODIFY_STATUS, 'json', bodyData, success, error)
    }

    /**
     * 获取入群欢迎语任务详情
     * @param taskId
     * @param success
     * @param error
     */
    static getRoomWelMsgDetail(taskId, success, error) {
        doGet(URL_GROUP_CHAT_ROOMWELMSG_DETAIL + `?taskId=${taskId}`, success, error)
    }

    /**
     *
     * @param bodyData
     * @param success
     * @param error
     */
    static editRoomWelMsg(bodyData, success, error) {
        doPost(URL_GROUP_CHAT_ROOMWELMSG_EDIT, 'json', bodyData, success, error)
    }

    /**
     * 创建入群欢迎语任务
     * @param bodyData
     * @param success
     * @param error
     */
    static createRoomWelMsg(bodyData, success, error) {
        doPost(URL_GROUP_CHAT_ROOMWELMSG_CREATE, 'json', bodyData, success, error)
    }

    /**
     * 获取欢迎语任务下拉列表数据
     */
    static getRoomWelMsgNameList(success, error) {
        doGet(URL_GROUP_CHAT_ROOMWELMSG_NAMELIST, success, error)
    }

    /**
     * 删除入群欢迎语任务
     * @param bodyData
     * @param success
     * @param error
     */
    static deleteRoomWelMsg(bodyData, success, error) {
        doPost(URL_GROUP_CHAT_ROOMWELMSG_DELETE, 'json', bodyData, success, error)
    }

    /**
     * 入群欢迎语任务列表查询
     * @param queryparam
     * @param bodyData
     * @param success
     * @param error
     */
    static getRoomWelMsgList(queryParam, bodyData, success, error) {
        let query = `?pageSize=${queryParam.pageSize}&pageNum=${queryParam.pageNum}`
        doPost(URL_GROUP_CHAT_ROOMWELMSG_LIST + query, 'json', bodyData, success, error)
    }

    /**
     * 区域数据
     * @param bodyData
     * @param success
     * @param error
     */
    static getLiveCodeReportArea(bodyData, success, error) {
        doPost(URL_GROUP_CHANT_LIVECODE_REPORT_AREA, 'json', bodyData, success, error)
    }

    /**
     * 数据走势
     * @param bodyData
     * @param success
     * @param error
     */
    static getLiveCodeReportLine(bodyData, success, error) {
        doPost(URL_GROUP_CHANT_LIVECODE_REPORT_LINE, 'json', bodyData, success, error)
    }

    /**
     * 数据明细
     * @param queryParam
     * @param bodyData
     * @param success
     * @param error
     */
    static getLiveCodeReportList(queryParam, bodyData, success, error) {
        let query = `?pageSize=${queryParam.pageSize}&pageNum=${queryParam.pageNum}`
        doPost(URL_GROUP_CHANT_LIVECODE_REPORT_LIST + query, 'json', bodyData, success, error)
    }

    /**
     * 扫码数据
     * @param bodyData
     * @param success
     * @param error
     */
    static getLiveCodeScanData(bodyData, success, error) {
        doPost(URL_GROUP_CHANT_LIVECODE_REPORT_SCANDATA, 'json', bodyData, success, error)
    }

    /**
     * 调整群聊顺序
     * @param bodyData
     * @param success
     * @param error
     */
    static orderLiveCodeInRoomList(bodyData, success, error) {
        doPost(URL_GROUP_CHAT_LIVECODE_ROOM_ORDER, 'json', bodyData, success, error)
    }

    /**
     * 停止/开启群聊分配
     * @param bodyData
     * @param success
     * @param error
     */
    static openOrStopRoomShowStatus(bodyData, success, error) {
        doPost(URL_GROUP_CHAT_LIVECODE_ROOM_OPEN_OR_STOP, 'json', bodyData, success, error)
    }

    /**
     * 创建群活码
     * @param bodyData
     * @param success
     * @param error
     */
    static editRlivecode(bodyData, success, error) {
        doPost(URL_GROUP_CHAT_LIVECODE_EDIT, 'json', bodyData, success, error)
    }

    /**
     * 获取群活码分组下拉列表
     * @param success
     * @param error
     */
    static getRoomlivecodeGroupList(success, error) {
        doGet(URL_GROUP_CHAT_LIVECODE_CODEGROUP_LIST, success, error)
    }

    static getRlivecodeRoomList(queryParam, bodyData, success, error) {
        let query = `?pageSize=${queryParam.pageSize}&pageNum=${queryParam.pageNum}`
        doPost(URL_GROUP_CHAT_LIVECODE_ROOMLIST + query, 'json', bodyData, success, error)
    }

    /**
     * 暂停/开启群活码
     * @param bodyData
     * @param success
     * @param error
     */
    static modifyRlivecodeStatus(bodyData, success, error) {
        doPost(URL_GROUP_CHAT_LIVECODE_MODIFY_STATUS, 'json', bodyData, success, error)
    }

    /**
     * 删除群活码
     * @param bodyData
     * @param success
     * @param error
     */
    static deleteRlivecode(bodyData, success, error) {
        doPost(URL_GROUP_CHAT_LIVECODE_DELETE, 'json', bodyData, success, error)
    }

    /**
     * 获取群活码详情
     * @param codeId
     * @param success
     * @param error
     */
    static getRlivecodeDetail(codeId, success, error) {
        doGet(URL_GROUP_CHAT_LIVECODE_DETAIL + `?codeId=${codeId}`, success, error)
    }

    /**
     * 创建群活码
     * @param bodyData
     * @param success
     * @param error
     */
    static createRlivecode(bodyData, success, error) {
        doPost(URL_GROUP_CHAT_LIVECODE_CREATE, 'json', bodyData, success, error)
    }

    /**
     * 群活码列表
     * @param bodyData
     * @param success
     * @param error
     */
    static getRlivecodeList(queryParam, bodyData, success, error) {
        let query = `?pageSize=${queryParam.pageSize}&pageNum=${queryParam.pageNum}`
        doPost(URL_GROUP_CHAT_LIVECODE_LIST + query, 'json', bodyData, success, error)
    }

    /**
     * 创建群公告任务
     * @param bodyData
     * @param success
     * @param error
     */
    static editChatNotice(bodyData, success, error) {
        doPost(URL_GROUP_CHAT_NOTICE_TASK_EDIT, 'json', bodyData, success, error)
    }

    /**
     * 获取群公告详情
     * @param taskId
     * @param success
     * @param error
     */
    static getGroupChatNoticeDetail(taskId, success, error) {
        doGet(URL_GROUP_CHAT_NOTICE_TASK_DETAIL + `?taskId=${taskId}`, success, error)
    }

    /**
     * 创建群公告任务
     * @param bodyData
     * @param success
     * @param error
     */
    static createChatNotice(bodyData, success, error) {
        doPost(URL_GROUP_CHAT_NOTICE_CREATE_TASK, 'json', bodyData, success, error)
    }

    /**
     * 开启群公告任务
     * @param taskId
     * @param success
     * @param error
     */
    static openChatNotice(taskId, success, error) {
        doGet(URL_GROUP_CHAT_NOTICE_OPEN_TASK + `?taskId=${taskId}`, success, error)
    }

    /**
     * 停止群公告任务
     * @param taskId
     * @param success
     * @param error
     */
    static stopChatNotice(taskId, success, error) {
        doGet(URL_GROUP_CHAT_NOTICE_STOP_TASK + `?taskId=${taskId}`, success, error)
    }

    /**
     * 删除群公告任务
     * @param taskId
     * @param success
     * @param error
     */
    static deleteChatNotice(taskId, success, error) {
        doGet(URL_GROUP_CHAT_NOTICE_DEL_TASK + `?taskId=${taskId}`, success, error)
    }

    /**
     * 群公告数据统计列表
     * @param queryParam
     * @param bodyData
     * @param success
     * @param error
     */
    static chatNoticeReportList(queryParam, bodyData, success, error) {
        let query = `?pageSize=${queryParam.pageSize}&pageNum=${queryParam.pageNum}&taskId=${queryParam.taskId}`
        doPost(URL_GROUP_CHAT_NOTICE_REPORT_LIST + query, 'json', bodyData, success, error)
    }

    /**
     * 群公告任务概览
     * @param taskId
     * @param success
     * @param error
     */
    static getChatNoticeOverView(taskId, success, error) {
        doGet(URL_GROUP_CHAT_NOTICE_REPORT_OVERVIEW + `?taskId=${taskId}`, success, error)
    }

    /**
     * 群公告名称下拉列表
     * @param success
     * @param error
     */
    static chatNoticeNameList(success, error) {
        doGet(URL_GROUP_CHAT_NOTICE_NAMELIST, success, error)
    }

    /**
     * 语音标记已读
     * @param bodyData
     * @param success
     * @param error
     */
    static chatAudioToListen(bodyData, success, error) {
        doPost(URL_CHAT_AUDIO_TO_LISTEN, 'json', bodyData, success, error)
    }

    /**
     * 语音识别
     * @param bodyData
     * @param success
     * @param error
     */
    static chatAudioToText(bodyData, success, error) {
        doPost(URL_CHAT_AUDIO_TO_TEXT, 'json', bodyData, success, error)
    }

    /**
     * 聊天 发送好友验证信息
     * @param wxid
     * @param success
     * @param error
     */
    static getChatAddFriendInfo(wxid, success, error) {
        doGet(URL_CHAT_SEND_ADD_FRIEND_INFO + `?wxid=${wxid}`, success, error)
    }

    /**
     * 聊天 发送好友验证
     * @param bodyData
     * @param success
     * @param error
     */
    static addChatFriend(bodyData, success, error) {
        doPost(URL_CHAT_SEND_ADD_FRIEND, 'json', bodyData, success, error)
    }

    /**
     * 群公告任务列表
     * @param queryParam
     * @param bodyData
     * @param success
     * @param error
     */
    static getGroupNoticeList(queryParam, bodyData, success, error) {
        let query = `?pageSize=${queryParam.pageSize}&pageNum=${queryParam.pageNum}`
        doPost(URL_GROUP_CHAT_NOTICE_LIST + query, 'json', bodyData, success, error)
    }

    /**
     * cloud首页 添加账号
     * @param bodyData
     * @param success
     * @param error
     */
    static addCloudHomeAccount(bodyData, success, error) {
        doPost(URL_CLOUD_HOME_ACCOUNT_ADD, 'json', bodyData, success, error)
    }

    /**
     * cloud首页 账号删除
     * @param bodyData
     * @param success
     * @param error
     */
    static deleteCloudHomeAccount(bodyData, success, error) {
        doPost(URL_CLOUD_HOME_ACCOUNT_DELETE, 'json', bodyData, success, error)
    }

    /**
     * cloud首页 账号下线
     * @param wxwUserId
     * @param success
     * @param error
     */
    static quitCloudHomeAccount(wxwUserId, success, error) {
        doPost(URL_CLOUD_HOME_ACCOUNT_QUIT + `?wxwUserId=${wxwUserId}`, 'json', {}, success, error)
    }

    /**
     * cloud首页 批量账号分组
     * @param bodyData
     * @param success
     * @param error
     */
    static setMoreCloudHomeGroup(bodyData, success, error) {
        doPost(URL_CLOUD_HOME_GROUP_SET_MORE, 'json', bodyData, success, error)
    }

    /**
     * cloud首页 账号分组新建
     * @param groupName
     * @param success
     * @param error
     */
    static deleteCloudHomeGroup(groupId, success, error) {
        doPost(URL_CLOUD_HOME_GROUP_DELETE + `?groupId=${groupId}`, 'json', {}, success, error)
    }

    /**
     * cloud首页 账号分组编辑
     * @param groupName
     * @param success
     * @param error
     */
    static editCloudHomeGroup(queryParam, success, error) {
        let query = `?groupId=${queryParam.groupId}&groupName=${queryParam.groupName}`
        doPost(URL_CLOUD_HOME_GROUP_EDIT + query, 'json', {}, success, error)
    }

    /**
     * cloud首页 账号分组新建
     * @param groupName
     * @param success
     * @param error
     */
    static addCloudHomeGroup(groupName, success, error) {
        doPost(URL_CLOUD_HOME_GROUP_ADD + `?groupName=${groupName}`, 'json', {}, success, error)
    }

    /**
     * cloud首页  账号分组列表
     * @param success
     * @param error
     */
    static cloudHomeGroupList(success, error) {
        doGet(URL_CLOUD_HOME_GROUP_LIST, success, error)
    }


    /**
     * cloud首页  账号分组下拉列表
     * @param success
     * @param error
     */
    static cloudHomeGroupNameList(success, error) {
        doGet(URL_CLOUD_HOME_GROUP_NAME_LIST, success, error)
    }

    /**
     * cloud首页 账号列表
     * @param queryParam
     * @param bodyData
     * @param success
     * @param error
     */
    static cloudHomeAccountList(queryParam, bodyData, success, error) {
        let query = `?pageSize=${queryParam.pageSize}&pageNum=${queryParam.pageNum}`
        doPost(URL_CLOUD_HOME_ACCOUNT_LIST + query, 'json', bodyData, success, error)
    }

    /**
     * cloud首页  账号概览
     * @param success
     * @param error
     */
    static getAccountOverview(success, error) {
        doGet(URL_CLOUD_HOME_ACCOUNT_OVERVIEW, success, error)
    }

    /**
     * 聊天配置开启聊天
     * @param bodyData
     * @param success
     * @param error
     */
    static doChatSettingsRadio(bodyData, success, error) {
        doPost(URL_CHAT_SETTINGS_RADIO, 'json', bodyData, success, error)
    }

    /**
     * 聊天配置 账号列表
     * @param queryParam
     * @param bodyData
     * @param success
     * @param error
     */
    static getChatSettingsList(queryParam, bodyData, success, error) {
        let query = `?pageSize=${queryParam.pageSize}&pageNum=${queryParam.pageNum}`
        doPost(URL_CHAT_SETTINGS_LIST + query, 'json', bodyData, success, error)
    }

    /**
     * 账号自动登录状态
     * @param wxwUserId
     * @param success
     * @param error
     */
    static chatLoginStatus(key, success, error) {
        doPost(URL_CHAT_WX_LOGIN_STATUS + `?key=${key}`, 'json', {}, success, error)
    }

    /**
     * 04 全局搜索
     * @param bodyData
     * @param success
     * @param error
     */
    static chetMsgSearch(bodyData, success, error) {
        doPost(URL_CHAT_MSG_SEARCH, 'json', bodyData, success, error)
    }

    /**
     * 账号自动登录席位
     * @param wxwUserId
     * @param success
     * @param error
     */
    static chatWxLogin(wxwUserId, success, error) {
        doPost(URL_CHAT_WX_LOGIN + `?wxwUserId=${wxwUserId}`, 'json', {}, success, error)
    }

    /**
     * 群成员
     * @param chatRoomId
     * @param success
     * @param error
     */
    static getChatRoomMember(chatRoomId, success, error) {
        doGet(URL_CHAT_GET_ROOM_MEMBER + `?chatRoomId=${chatRoomId}`, success, error)
    }

    /**
     * 获取消息文件的 url
     * @param wxid
     * @param msgId
     * @param success
     * @param error
     */
    static getChatFileUrl(bodyData, success, error) {
        doPost(URL_GET_CHAT_GET_FILE_URL, 'json', bodyData, success, error)
    }

    /**
     * 修改群名称
     * @param bodyData
     * @param success
     * @param error
     */
    static updateChatRoomName(bodyData, success, error) {
        doPost(URL_GET_CHAT_UPDATE_ROOM_NAME, 'json', bodyData, success, error)
    }

    /**
     * 03 获取消息列表
     * @param queryParam
     * @param bodyData
     * @param success
     * @param error
     */
    static getChatMsgs(queryParam, bodyData, success, error) {
        let query = `?pageSize=${queryParam.pageSize}&pageNum=${queryParam.pageNum}`
        doPost(URL_GET_CHAT_MSG + query, 'json', bodyData, success, error)
    }

    /**
     * 群管理转让群主列表
     * @param bodyData
     * @param success
     * @param error
     */
    static getInternalMembers(bodyData, success, error) {
        doPost(URL_GROUPCHAT_MANAGE_OWNERLIST_NEW, 'json', bodyData, success, error)
    }

    /**
     * 群关键词 查看群聊
     * @param queryParam
     * @param success
     * @param error
     */
    static groupKeywordDetailList(queryParam, success, error) {
        let query = `?ruleId=${queryParam.ruleId}&pageSize=${queryParam.pageSize}&pageNum=${queryParam.pageNum}`
        doGet(URL_GROUPCHAT_KEYWORD_GROUPDETAIL_LIST + query, success, error)
    }

    /**
     * 打开关闭违规检测任务
     * @param queryParam
     * @param success
     * @param error
     */
    static switchErrorCheck(queryParam, success, error) {
        let query = `?id=${queryParam.id}&radio=${queryParam.radio}`
        doPost(URL_GROUPCHAT_ERRORCHECK_SWITCH + query, 'json', {}, success, error)
    }

    /**
     * 获取违规检测记录
     * @param queryParam
     * @param bodyData
     * @param success
     * @param error
     */
    static getErrorCheckReportList(queryParam, bodyData, success, error) {
        let query = `?pageSize=${queryParam.pageSize}&pageNum=${queryParam.pageNum}`
        doPost(URL_GROUPCHAT_ERRORCHECK_REPORT_LIST + query, 'json', bodyData, success, error)
    }

    /**
     * 获取违规检测任务详情
     * @param taskId
     * @param success
     * @param error
     */
    static getErrorCheckDetail(id, success, error) {
        doGet(URL_GROUPCHAT_ERRORCHECK_DETAIL + `?id=${id}`, success, error)
    }

    /**
     * 编辑违规检测任务
     * @param bodyData
     * @param success
     * @param error
     */
    static editErrorCheck(bodyData, success, error) {
        doPost(URL_GROUPCHAT_ERRORCHECK_EDIT, 'json', bodyData, success, error)
    }

    /**
     * 群管理 添加标签
     * @param bodyData
     * @param success
     * @param error
     */
    static addGroupManageTag(bodyData, success, error) {
        doPost(URL_GROUP_GROUPACCOUNT_ADDTAG, 'json', bodyData, success, error)
    }

    /**
     * 群关键词 编辑任务
     * @param bodyData
     * @param success
     * @param error
     */
    static editGroupKeyword(bodyData, success, error) {
        doPost(URL_GROUPCHAT_KEYWORD_EDIT, 'json', bodyData, success, error)
    }

    /**
     * 群关键词 获取任务详情
     * @param id
     * @param success
     * @param error
     */
    static getGroupKeywordDetail(id, success, error) {
        doGet(URL_GROUPCHAT_KEYWORD_DETAIL + `?id=${id}`, success, error)
    }

    /**
     * 群关键词 创建任务
     * @param bodyData
     * @param success
     * @param error
     */
    static createGroupKeyword(bodyData, success, error) {
        doPost(URL_GROUPCHAT_KEYWORD_CREATE, 'json', bodyData, success, error)
    }

    /**
     * 群关键词 群聊名称下拉
     * @param ruleId
     * @param success
     * @param error
     */
    static getGroupKeywordRoomList(ruleId, success, error) {
        doGet(URL_GROUPCHAT_KEYWORD_ROOMLIST + `?ruleId=${ruleId}`, success, error)
    }

    /**
     * 群关键词 任务名称下拉
     * @param success
     * @param error
     */
    static getGroupKeywordNameList(success, error) {
        doGet(URL_GROUPCHAT_KEYWORD_NAMELIST, success, error)
    }

    /**
     * 群关键词 数据统计列表
     * @param queryParam
     * @param bodyData
     * @param success
     * @param error
     */
    static getGroupKeywordReportList(queryParam, bodyData, success, error) {
        let query = `?pageSize=${queryParam.pageSize}&pageNum=${queryParam.pageNum}`
        doPost(URL_GROUPCHAT_KEYWORD_REPORT_LIST + query, 'json', bodyData, success, error)
    }

    /**
     * 群关键词 删除任务
     * @param id
     * @param success
     * @param error
     */
    static deleteGroupKeyword(id, success, error) {
        doGet(URL_GROUPCHAT_KEYWORD_DELETE + `?id=${id}`, success, error)
    }

    /**
     * 群关键词 任务列表
     * @param queryParam
     * @param bodyData
     * @param success
     * @param error
     */
    static getGroupKeywordList(queryParam, bodyData, success, error) {
        let query = `?pageSize=${queryParam.pageSize}&pageNum=${queryParam.pageNum}`
        doPost(URL_GROUPCHAT_KEYWORD_LIST + query, 'json', bodyData, success, error)
    }

    /**
     * 创建违规检测任务
     * @param bodyData
     * @param success
     * @param error
     */
    static createErrorCheck(bodyData, success, error) {
        doPost(URL_GROUPCHAT_ERRORCHECK_CREATE, 'json', bodyData, success, error)
    }

    /**
     * 获取违规检测任务名称列表
     * @param success
     * @param error
     */
    static getErrorCheckNameList(success, error) {
        doGet(URL_GROUPCHAT_ERRORCHECK_NAMELIST, success, error)
    }

    /**
     * 删除违规检测任务
     * @param bodyData
     * @param success
     * @param error
     */
    static deleteErrorCheck(bodyData, success, error) {
        doPost(URL_GROUPCHAT_ERRORCHECK_DELETE, 'json', bodyData, success, error)
    }

    /**
     * 违规检测任务列表
     * @param queryParam
     * @param success
     * @param error
     */
    static errorCheckList(queryParam, bodyData, success, error) {
        let query = `?pageSize=${queryParam.pageSize}&pageNum=${queryParam.pageNum}`
        doPost(URL_GROUPCHAT_ERRORCHECK_LIST + query, 'json', bodyData, success, error)
    }

    /**
     * 领取新人专属优惠
     * @param success
     * @param error
     */
    static receiveGift(success, error) {
        doGet(URL_SEAT_GIFT_RECEIVE, success, error)
    }

    /**
     * 获取即将过期席位
     * @param success
     * @param error
     */
    static seatExpiringSeats(success, error) {
        doGet(URL_SEAT_EXPIRING_SEATS, success, error)
    }

    /**
     * 新人专属优惠领取状态
     * @param success
     * @param error
     */
    static getGiftStatus(success, error) {
        doGet(URL_SEAT_GIFT_STATUS, success, error)
    }

    /**
     * 好有备注  数据统计  账号下拉
     * @param id
     * @param success
     * @param error
     */
    static getRemarkReportAccount(id, success, error) {
        doGet(URL_ACCOUNT_REMARK_REPORT_ACCOUNT_NAMELIST + `?id=${id}`, success, error)
    }

    /**
     * 群管理  管理账号列表
     * @param bodyData
     * @param success
     * @param error
     */
    static getGroupManageAccount(bodyData, success, error) {
        doPost(URL_GROUP_GROUPACCOUNT_LIST, 'json', bodyData, success, error)
    }

    /**
     * 席位  绑定公司名称
     * @param corpName
     * @param success
     * @param error
     */
    static seatBindName(corpName, success, error) {
        doPost(URL_SEAT_BIND_NAME + `?corpName=${corpName}`, 'json', {}, success, error)
    }

    /**
     * 群聊群发任务详情
     * @param id
     * @param success
     * @param error
     */
    static getGroupSendDetail(id, success, error) {
        doGet(URL_GROUP_SEND_DETAIL + `?taskId=${id}`, success, error)
    }

    /**
     * 编辑群聊群发任务
     * @param bodyData
     * @param success
     * @param error
     */
    static editGroupSend(bodyData, success, error) {
        doPost(URL_GROUP_SEND_EDIT, 'json', bodyData, success, error)
    }

    /**
     * 创建群聊群发任务
     * @param bodyData
     * @param success
     * @param error
     */
    static createGroupSend(bodyData, success, error) {
        doPost(URL_GROUP_SEND_CREATE, 'json', bodyData, success, error)
    }

    /**
     *  好友群发 开启任务
     * @param requestId
     * @param success
     * @param error
     */
    static openGroupSend(id, success, error) {
        doGet(URL_GROUP_SEND_OPEN_TASK + `?taskId=${id}`, success, error)
    }

    /**
     *  好友群发 停止任务
     * @param requestId
     * @param success
     * @param error
     */
    static stopGroupSend(id, success, error) {
        doGet(URL_GROUP_SEND_STOP_TASK + `?taskId=${id}`, success, error)
    }

    /**
     *  好友群发 删除任务
     * @param requestId
     * @param success
     * @param error
     */
    static deleteGroupSend(id, success, error) {
        doGet(URL_GROUP_SEND_DELETE_TASK + `?taskId=${id}`, success, error)
    }

    /**
     * 好友群发 账号下拉
     * @param id
     * @param success
     * @param error
     */
    static getGroupSendAcountList(id, success, error) {
        doGet(URL_GROUP_SEND_REPORT_ACCOUNT_NAMELIST + `?taskId=${id}`, success, error)
    }

    /**
     * 好友群发 群发列表
     * @param queryParam
     * @param bodyData
     * @param success
     * @param error
     */
    static getGroupSendReportList(queryParam, bodyData, success, error) {
        let query = `?pageNum=${queryParam.pageNum}&pageSize=${queryParam.pageSize}&taskId=${queryParam.taskId}`
        doPost(URL_GROUP_SEND_REPORT_LIST + query, 'json', bodyData, success, error)
    }

    /**
     * 群发统计
     * @param id
     * @param success
     * @param error
     */
    static getGroupSendStats(id, success, error) {
        doGet(URL_GROUP_SEND_REPORT_STATS + `?taskId=${id}`, success, error)
    }

    /**
     * 任务下拉
     * @param success
     * @param error
     */
    static getGroupSendNameList(success, error) {
        doGet(URL_GROUP_SEND_NAME_LIST, success, error)
    }

    /**
     * 群聊群发任务列表
     * @param queryParam
     * @param bodyData
     * @param success
     * @param error
     */
    static getGroupSendList(queryParam, bodyData, success, error) {
        let query = `?pageNum=${queryParam.pageNum}&pageSize=${queryParam.pageSize}`
        doPost(URL_GROUP_SEND_LIST + query, 'json', bodyData, success, error)
    }

    /**
     * 删除群标签组
     * @param id
     * @param success
     * @param error
     */
    static groupTagDelete(id, success, error) {
        doGet(URL_GROUP_TAGLIST_DELETE + `?tagGroupId=${id}`, success, error)
    }

    /**
     * 编辑群标签组
     * @param bodyData
     * @param success
     * @param error
     */
    static groupTagSave(bodyData, success, error) {
        doPost(URL_GROUP_TAGLIST_SAVE, 'json', bodyData, success, error)
    }

    /**
     * 编辑群标签组
     * @param bodyData
     * @param success
     * @param error
     */
    static groupTagEdit(bodyData, success, error) {
        doPost(URL_GROUP_TAGLIST_EDIT, 'json', bodyData, success, error)
    }

    /**
     * 添加标签
     * @param bodyData
     * @param success
     * @param error
     */
    static groupTagAdd(bodyData, success, error) {
        doPost(URL_GROUP_TAGLIST_ADD, 'json', bodyData, success, error)
    }

    /**
     *  交换顺序
     * @param bodyData
     * @param success
     * @param error
     */
    static changeTagOrder(bodyData, success, error) {
        doPost(URL_GROUP_TAGLIST_CHANGE_ORDER, 'json', bodyData, success, error)
    }

    /**
     * 群主列表
     * @param success
     * @param error
     */
    static getGroupOwnerList(success, error) {
        doGet(URL_GROUP_GROUPOWNER_LIST, success, error)
    }

    /**
     * 转让群主
     * @param bodyData
     * @param success
     * @param error
     */
    static changeGroupOwner(bodyData, success, error) {
        doPost(URL_GROUP_GROUPOWNER_CHANGE, 'json', bodyData, success, error)
    }


    /**
     * 群管理员变更管理
     * @param bodyData
     * @param success
     * @param error
     */
    static changeGroupManager(bodyData, success, error) {
        doPost(URL_GROUP_GROUPMANAGER_CHANGE, 'json', bodyData, success, error)
    }

    /**
     * 群管理员列表
     * @param success
     * @param error
     */
    static getGroupManagerList(success, error) {
        doGet(URL_GROUP_GROUPMANAGER_LIST, success, error)
    }

    /**
     * 同步群聊列表
     * @param success
     * @param error
     */
    static syncGroupManageList(success, error) {
        doPost(URL_GROUP_SYNC_MANAGE_LIST, 'json', {}, success, error)
    }

    /**
     * 批量移除标签
     * @param bodyData
     * @param success
     * @param error
     */
    static deleteGroupTag(bodyData, success, error) {
        doPost(URL_GROUP_MANAGE_DELETE_TAG, 'json', bodyData, success, error)
    }

    /**
     * 批量打标签
     * @param bodyData
     * @param success
     * @param error
     */
    static addGroupTag(bodyData, success, error) {
        doPost(URL_GROUP_MANAGE_ADD_TAG, 'json', bodyData, success, error)
    }

    /**
     * 群标签
     * @param bodyData
     * @param success
     * @param error
     */
    static getGroupManageGroupTag(bodyData, success, error) {
        doPost(URL_GROUP_MANAGE_GROUPTAG, 'json', bodyData, success, error)
    }

    /**
     * 好友群发 群发列表
     * @param queryParam
     * @param bodyData
     * @param success
     * @param error
     */
    static getGroupManageList(queryParam, bodyData, success, error) {
        let query = `?pageNum=${queryParam.pageNum}&pageSize=${queryParam.pageSize}`
        doPost(URL_GROUP_MANAGE_LIST + query, 'json', bodyData, success, error)
    }

    /**
     * 好友群发 账号下拉
     * @param id
     * @param success
     * @param error
     */
    static getFriendGroupSendAcountList(id, success, error) {
        doGet(URL_CUSTOMER_GROUPSEND_ACCOUNTLIST + `?requstId=${id}`, success, error)
    }

    /**
     * 好友群发 群发列表
     * @param queryParam
     * @param bodyData
     * @param success
     * @param error
     */
    static getFriendGroupSendReport(queryParam, bodyData, success, error) {
        let query = `?pageNum=${queryParam.pageNum}&pageSize=${queryParam.pageSize}&requestId=${queryParam.requestId}`
        doPost(URL_CUSTOMER_GROUPSEND_REPORTLIST + query, 'json', bodyData, success, error)
    }

    /**
     * 好友群发 活动下拉
     * @param success
     * @param error
     */
    static getFriendGroupSendNameList(success, error) {
        doGet(URL_CUSTOMER_GROUPSEND_NAMELIST, success, error)
    }

    /**
     * 好友群发 群发统计
     * @param id
     * @param success
     * @param error
     */
    static getFriendGroupSendStats(id, success, error) {
        doGet(URL_CUSTOMER_GROUPSEND_STATS + `?requestId=${id}`, success, error)
    }

    /**
     * 好友群发 统计客户
     * @param bodyData
     * @param sucess
     * @param error
     */
    static getFriendCountCustomer(bodyData, sucess, error) {
        doPost(URL_CUSTOMER_GROUPSEND_COUNTCUSTOMER, 'json', bodyData, success, error)
    }

    /**
     *  好友群发 开启任务
     * @param requestId
     * @param success
     * @param error
     */
    static openFriendGroupSend(requestId, success, error) {
        doGet(URL_CUSTOMER_GROUPSEND_OPEN + `?requestId=${requestId}`, success, error)
    }

    /**
     *  好友群发 停止任务
     * @param requestId
     * @param success
     * @param error
     */
    static stopFriendGroupSend(requestId, success, error) {
        doGet(URL_CUSTOMER_GROUPSEND_STOP + `?requestId=${requestId}`, success, error)
    }

    /**
     *  好友群发 删除任务
     * @param requestId
     * @param success
     * @param error
     */
    static deleteFriendGroupSend(requestId, success, error) {
        doGet(URL_CUSTOMER_GROUPSEND_DELETE + `?requestId=${requestId}`, success, error)
    }

    /**
     * 好友群发 活动详情
     * @param requestId
     * @param success
     * @param error
     */
    static getFriendGroupSendDetail(requestId, success, error) {
        doGet(URL_CUSTOMER_GROUPSEND_DETAIL + `?requestId=${requestId}`, success, error)
    }

    /**
     * 好友群发 任务列表
     * @param queryParam
     * @param bodyData
     * @param success
     * @param error
     */
    static getFriendGroupSendList(queryParam, bodyData, success, error) {
        let query = `?pageNum=${queryParam.pageNum}&pageSize=${queryParam.pageSize}`
        doPost(URL_CUSTOMER_GROUPSEND_LIST + query, 'json', bodyData, success, error)
    }

    /**
     * 好友群发 创建活动
     * @param bodyData
     * @param success
     * @param error
     */
    static editFriendGroupSend(bodyData, success, error) {
        doPost(URL_CUSTOMER_GROUPSEND_EDIT, 'json', bodyData, success, error)
    }

    /**
     * 好友群发 创建活动
     * @param bodyData
     * @param success
     * @param error
     */
    static createFriendGroupSend(bodyData, success, error) {
        doPost(URL_CUSTOMER_GROUPSEND_CREATE, 'json', bodyData, success, error)
    }

    /**
     * 规则数据下拉列表
     * @param success
     * @param error
     */
    static getKeywordReportNameLIst(success, error) {
        doGet(URL_CUSTOMER_KEYWORD_REPORT_NAMELIST, success, error)
    }

    /**
     * 规则数据
     * @param queryParam
     * @param bodyData
     * @param success
     * @param error
     */
    static getKeywordReportList(queryParam, bodyData, success, error) {
        let query = `?pageNum=${queryParam.pageNum}&pageSize=${queryParam.pageSize}`
        doPost(URL_CUSTOMER_KEYWORD_REPORT + query, 'json', bodyData, success, error)
    }

    /**
     * 删除任务
     * @param bodyData
     * @param success
     * @param error
     */
    static deleteKeyword(id, success, error) {
        doGet(URL_CUSTOMER_KEYWORD_DELETE + `?id=${id}`, success, error)
    }

    /**
     * 获取任务详情
     * @param id
     * @param success
     * @param error
     */
    static getKeywordDetail(id, success, error) {
        doGet(URL_CUSTOMER_KEYWORD_DETAIL + `?id=${id}`, success, error)
    }

    /**
     * 关键词回复  创建任务
     * @param bodyData
     * @param success
     * @param error
     */
    static editKeyword(bodyData, success, error) {
        doPost(URL_CUSTOMER_KEYWORD_EDIT, 'json', bodyData, success, error)
    }

    /**
     * 关键词回复  创建任务
     * @param bodyData
     * @param success
     * @param error
     */
    static createKeyword(bodyData, success, error) {
        doPost(URL_CUSTOMER_KEYWORD_CREATE, 'json', bodyData, success, error)
    }

    /**
     * 关键词 状态开关
     * @param queryParam
     * @param success
     * @param error
     */
    static switchKeywordList(queryParam, success, error) {
        let query = `?taskId=${queryParam.taskId}&radioValue=${queryParam.radioValue}`
        doGet(URL_CUSTOMER_KEYWORD_SWITCH + query, success, error)
    }

    /**
     * 客户触达 规则列表
     * @param queryParam
     * @param bodyData
     * @param success
     * @param error
     */
    static getKeywordList(queryParam, bodyData, success, error) {
        let query = `?pageNum=${queryParam.pageNum}&pageSize=${queryParam.pageSize}`
        doPost(URL_CUSTOMER_KEYWORD + query, 'json', bodyData, success, error)
    }

    /**
     * 好友备注 规则详情
     * @param id
     * @param success
     * @param error
     */
    static getRemarkDetail(id, success, error) {
        doGet(URL_ACCOUNT_REMARK_DETAIL + `?id=${id}`, success, error)
    }

    /**
     * 好友备注 规则删除
     * @param id
     * @param success
     * @param error
     */
    static deleteRemark(id, success, error) {
        doPost(URL_ACCOUNT_REMARK_DELETE + `?id=${id}`, 'json', '', success, error)
    }

    /**
     * 好友备注 账号下拉
     * @param success
     * @param error
     */
    static getAccountNameList(success, error) {
        doGet(URL_ACCOUNT_REMARK_ACCOUNT_NAMELIST, success, error)
    }

    /**
     * 好友备注 新建好友备注规则
     * @param bodyData
     * @param success
     * @param error
     */
    static editRemark(bodyData, success, error) {
        doPost(URL_ACCOUNT_REMARK_EDIT, 'json', bodyData, success, error)
    }

    /**
     * 好友备注 新建好友备注规则
     * @param bodyData
     * @param success
     * @param error
     */
    static createRemark(bodyData, success, error) {
        doPost(URL_ACCOUNT_REMARK_CREATE, 'json', bodyData, success, error)
    }

    /**
     * 好友备注 规则数据列表
     * @param queryParam
     * @param bodyData
     * @param success
     * @param error
     */
    static getRemarkReportList(queryParam, bodyData, success, error) {
        let query = `?pageNum=${queryParam.pageNum}&pageSize=${queryParam.pageSize}`
        doPost(URL_ACCOUNT_REMARK_REPORT_LIST + query, 'json', bodyData, success, error)
    }

    /**
     * 好友备注 规则下拉列表
     * @param success
     * @param error
     */
    static getRemarkNameList(success, error) {
        doGet(URL_ACCOUNT_REMARK_RULE_NAMELIST, success, error)
    }

    /**
     * 好友备注 好友备注列表
     * @param queryParam
     * @param bodyData
     * @param success
     * @param error
     */
    static getRemarkList(queryParam, bodyData, success, error) {
        let query = `?pageNum=${queryParam.pageNum}&pageSize=${queryParam.pageSize}`
        doPost(URL_ACCOUNT_REMARK_LIST + query, 'json', bodyData, success, error)
    }

    /**
     * 设置自动通过好友请求
     * @param bodyData
     * @param seccess
     * @param error
     */
    static setAutoFriend(bodyData, seccess, error) {
        doPost(URL_ACCOUNT_AUTOFRIEND, 'json', bodyData, seccess, error)
    }

    /**
     * 账号列表
     * @param queryParam
     * @param bodyData
     * @param success
     * @param error
     */
    static getAccountList(queryParam, bodyData, success, error) {
        let query = `?pageNum=${queryParam.pageNum}&pageSize=${queryParam.pageSize}`
        doPost(URL_ACCOUNT_LIST + query, 'json', bodyData, success, error)
    }

    /**
     * 新的账号列表
     * @param bodyData
     * @param success
     * @param error
     */
    static getNewAccountList(bodyData, success, error) {
        doPost(URL_ACCOUNT_GET_ACCOUNT_LIST, 'json', bodyData, success, error)
    }

    /**
     *  登录席位状态
     * @param seatId
     * @param success
     * @param error
     */
    static getSeatLoginStatus(seatId, success, error) {
        doPost(URL_SEAT_LOGIN_STATUS + `?seatId=${seatId}`, 'json', {}, success, error)
    }

    /**
     * 查询支付结果
     * @param orderId
     * @param success
     * @param error
     */
    static getSeatPayResult(orderId, success, error) {
        doGet(URL_SEAT_PAY_RESULT + `?orderId=${orderId}`, success, error)
    }

    /**
     * 席位收款二维码
     * @param orderId
     * @param success
     * @param error
     */
    static getPayCode(orderId, success, error) {
        doGet(URL_SEAT_PAY_CODE + `?orderId=${orderId}`, success, error)
    }

    /**
     * 席位购买下单
     * @param bodyData
     * @param success
     * @param error
     */
    static getSeatOrder(bodyData, success, error) {
        doPost(URL_SEAT_GET_ORDER, 'json', bodyData, success, error)
    }

    /**
     * 席位计价
     * @param bodyData
     * @param success
     * @param error
     */
    static getCalprcie(bodyData, success, error) {
        doPost(URL_SEAT_CALC_PRICE, 'json', bodyData, success, error)
    }

    /**
     * 购买席位信息
     * @param success
     * @param error
     */
    static getSeatInfo(success, error) {
        doGet(URL_SEAT_PRODUCT_INFO, success, error)
    }

    /**
     * 下线席位
     * @param id
     * @param success
     * @param error
     */
    static quitSeat(seatId, wxwUserId, success, error) {
        doPost(URL_SEAT_QUIT + `?wxwUserId=${wxwUserId}&seatId=${seatId}`, 'json', {}, success, error)
    }

    /**
     * 登录席位
     * @param id
     * @param success
     * @param error
     */
    static loginSeat(seatId, success, error) {
        doPost(URL_SEAT_LOGIN + `?seatId=${seatId}`, 'json', {}, success, error)
    }

    /**
     * 批量分组席位
     * @param bodyData
     * @param success
     * @param error
     */
    static setSeatGroup(bodyData, success, error) {
        doPost(URL_SEAT_SET_GROUP, 'json', bodyData, success, error)
    }

    /**
     * 删除席位分组
     * @param groupId
     * @param success
     * @param error
     */
    static deleteSeatGroup(groupId, success, error) {
        let query = `?groupId=${groupId}`
        doPost(URL_SEAT_DELETE_GROUP + query, 'json', {}, success, error)
    }

    /**
     * 编辑席位分组
     * @param queryParam
     * @param success
     * @param error
     */
    static editSeatGroup(queryParam, success, error) {
        let query = `?groupId=${queryParam.groupId}&groupName=${queryParam.groupName}`
        doPost(URL_SEAT_EDIT_GROUP + query, 'json', {}, success, error)
    }

    /**
     * 新建席位分组
     * @param groupName
     * @param success
     * @param error
     */
    static addSeatGroup(groupName, success, error) {
        doPost(URL_SEAT_ADD_GROUP + `?groupName=${groupName}`, 'json', {}, success, error)
    }

    /**
     *  席位分组详情
     * @param success
     * @param error
     */
    static getSeatGroupList(success, error) {
        doGet(URL_SEAT_GROUP_LIST, success, error)
    }

    /**
     * 席位概览
     * @param success
     * @param error
     */
    static getSeatViewData(success, error) {
        doGet(URL_SEAT_VIEW_DATA, success, error)
    }

    /**
     * 席位分组下拉列表
     * @param success
     * @param error
     */
    static getSeatNameList(success, error) {
        doGet(URL_SEAT_GROUP_NAMELIST, success, error)
    }

    /**
     * 席位列表
     * @param queryParam
     * @param bodyData
     * @param success
     * @param error
     */
    static getSeatList(queryParam, bodyData, success, error) {
        let query = `?pageNum=${queryParam.pageNum}&pageSize=${queryParam.pageSize}`
        doPost(URL_SEAT_LIST + query, 'json', bodyData, success, error)
    }

    /**
     * 02 zk用户所有账号列表
     * @param success
     * @param error
     */
    static getAccountLists(success, error) {
        doGet(URL_ACCOUNT_LIST, success, error)
    }


    /**
     * 08 手机号添加好友任务列表
     * @param bodyData{taskName,status}
     * @param success
     * @param error
     */
    static getAccountPhoneFriendList(pageNum, pageSize, bodyData, success, error) {
        doPost(URL_ACCOUNT_PHONE_FRIEND_LIST + '?pageNum=' + pageNum + '&pageSize=' + pageSize, 'json', bodyData, success, error)
    }

    /**
     * 07 手机号添加好友任务
     * @param bodyData
     * @param success
     * @param error
     */
    static getAccountPhoneFriendCreate(bodyData, success, error) {
        doPost(URL_ACCOUNT_PHONE_FRIEND_CREATE, 'file', bodyData, success, error)
    }

    /**
     * 07 获取任务详情接口
     * @param phoneFriendId
     * @param success
     * @param error
     */
    static getAccountPhoneFriendDetail(phoneFriendId, success, error) {
        doGet(URL_ACCOUNT_PHONE_FRIEND_DETAIL + '?phoneFriendId=' + phoneFriendId, success, error)
    }

    /**
     * 07 编辑接口
     * @param bodyData
     * @param success
     * @param error
     */
    static getAccountPhoneFriendEdit(bodyData, success, error) {
        doPost(URL_ACCOUNT_PHONE_FRIEND_EDIT, 'json', bodyData, success, error)
    }

    /**
     * 停止
     * @param phoneFriendId
     * @param success
     * @param error
     */
    static getAccountPhoneFriendStop(phoneFriendId, success, error) {
        doPost(URL_ACCOUNT_PHONE_FRIEND_STOP + '?phoneFriendId=' + phoneFriendId, 'json', {}, success, error)
    }

    /**
     * 07.4 获取标签列表
     * @param bodyData
     * @param success
     * @param error
     */
    static getAccountPhoneFriendCorpTags(tagName, success, error) {
        doGet(URL_ACCOUNT_PHONE_FRIEND_CORP_TAGS + '?tagName=' + tagName, success, error)
    }

    /**
     * 08.1 手机号添加好友任务名称列表
     * @param success
     * @param error
     */
    static getAccountPhoneFriendNameList(success, error) {
        doGet(URL_ACCOUNT_PHONE_FRIEND_NAME_LIST, success, error)
    }

    /**
     *09 手机号添加好友任务信息
     * @param phoneFriendId
     * @param success
     * @param error
     */
    static getAccountPhoneFriendTaskInfo(params, success, error) {
        let query = '?phoneFriendId=' + params.phoneFriendId
        doGet(URL_ACCOUNT_PHONE_FRIEND_TASK_INFO + query, success, error)
    }

    /**
     *10 手机号添加好友任务手机号数据
     * @param pageNum
     * @param pageSize
     * @param bodyData{phoneFriendId，phoneNo，wxwUserId，status}
     * @param success
     * @param error
     */
    static getAccountPhoneRecord(pageNum, pageSize, bodyData, success, error) {
        doPost(URL_ACCOUNT_PHONE_FRIEND_PHONE_RECORD + '?pageNum=' + pageNum + '&pageSize=' + pageSize, 'json', bodyData, success, error)
    }

    /**
     *09.1 手机号添加好友任务账号列表
     * @param phoneFriendId
     * @param success
     * @param error
     */
    static getAccountPhoneFriendTaskAccount(phoneFriendId, success, error) {
        doGet(URL_ACCOUNT_PHONE_FRIEND_TASK_ACCOUNT + '?phoneFriendId=' + phoneFriendId, success, error)
    }

    /**
     *09.1 手机号添加好友任务账号列表开启
     * @param phoneFriendId
     * @param success
     * @param error
     */
    static getAccountPhoneFriendOpen(phoneFriendId, success, error) {
        doPost(URL_ACCOUNT_PHONE_FRUEND_OPEN + '?phoneFriendId=' + phoneFriendId, 'json', {}, success, error)
    }

    /**
     *09.1 手机号添加好友任务删除
     * @param phoneFriendId
     * @param success
     * @param error
     */
    static getAccountPhoneFriendDel(phoneFriendId, success, error) {
        doPost(URL_ACCOUNT_PHONE_FRIEND_DEL + '?phoneFriendId=' + phoneFriendId, 'json', {}, success, error)
    }

    /**
     *09.1 群添加好友任务删除
     * @param groupFriendId
     * @param success
     * @param error
     */
    static getAccountGroupFriendDel(groupFriendId, success, error) {
        doGet(URL_ACCOUNT_GROUP_FRIEND_DEL + '?groupFriendId=' + groupFriendId, success, error)
    }

    /**
     *12 群成员添加好友任务列表
     * @param pageNum
     * @param pageSize
     * @param bodyData
     * @param success
     * @param error
     */
    static getAccountGroupFriendList(pageNum, pageSize, bodyData, success, error) {
        doPost(URL_ACCOUNT_GROUP_FRIEND_LIST + '?pageNum=' + pageNum + '&pageSize=' + pageSize, 'json', bodyData, success, error)
    }

    /**
     * 16 获取全部外部群聊列表
     * @param groupFriendId  裂变活动ID，编辑时有该字段，复制、新建时不传
     * @param success
     * @param error
     */
    static getAccountGroupFriendGroupChatList(groupFriendId, success, error) {
        doGet(URL_ACCOUNT_GROUNP_FRIEND_GROUP_CHAT_LIST + '?groupFriendId=' + groupFriendId, success, error)
    }

    /**
     * 11 群成员添加好友任务
     * @param bodyData
     * @param success
     * @param error
     */
    static getAccountGroupFriendCreate(bodyData, success, error) {
        doPost(URL_ACCOUNT_GROUP_FRIEND_CREATE, 'json', bodyData, success, error)
    }

    /**
     * 11.2 群成员添加好友任务详情
     * @param groupFriendId
     * @param success
     * @param error
     */
    static getAccountGroupFriendDetail(groupFriendId, success, error) {
        doGet(URL_ACCOUNT_GROUP_FRIEND_DETAIL + '?groupFriendId=' + groupFriendId, success, error)
    }

    /**
     * 11.2 群成员编辑好友任务
     * @param bodyData
     * @param success
     * @param error
     */
    static getAccountFriendEdit(bodyData, success, error) {
        doPost(URL_ACCOUNT_GROUP_FRIEND_EDIT, 'json', bodyData, success, error)
    }

    /**
     * 11.3 群成员添加好友任务停止
     * @param groupFriendId
     * @param success
     * @param error
     */
    static getAccountGroupFriendStop(groupFriendId, success, error) {
        doGet(URL_ACCOUNT_GROUP_FRIEND_STOP + '?groupFriendId=' + groupFriendId, success, error)
    }

    /**
     * 15.3 群聊添加好友任务名称列表
     * @param success
     * @param error
     */
    static getAccountGroupFriendNameList(success, error) {
        doPost(URL_ACCOUNT_GROUP_FRIEND_NAME_LIST, 'json', {}, success, error)
    }

    /**
     * 13 群聊添加好友任务信息
     * @param groupFriendId
     * @param success
     * @param error
     */
    static getAccountGroupFriendTaskInfo(groupFriendId, success, error) {
        doGet(URL_ACCOUNT_GROUP_FRIEND_TASK_INFO + '?groupFriendId=' + groupFriendId, success, error)
    }

    /**
     * 15 群聊添加好友任务群聊数据
     * @param bodyData{groupFriendId,groupchatName,hasComplete}
     * @param success
     * @param error
     */
    static getAccountGroupFriendGroupList(bodyData, success, error) {
        doPost(URL_ACCOUNT_GROUP_FRIEND_GROUP_LIST, 'json', bodyData, success, error)
    }

    /**
     * 14 群聊添加好友任务群成员数据
     * @param bodyData{groupFriendId,groupchatName,hasComplete}
     * @param success
     * @param error
     */
    static getAccountGroupFriendMemberList(pageNum, pageSize, bodyData, success, error) {
        doPost(URL_ACCOUNT_GROUP_FRIEND_MEMBER_LIST + '?pageNum=' + pageNum + '&pageSize=' + pageSize, 'json', bodyData, success, error)
    }

    /**
     * 15.1 群聊添加好友任务删除群聊
     * @param bodyData{groupFriendId,groupchatId}
     * @param success
     * @param error
     */
    static getAccountGroupFriendGroupChatDel(bodyData, success, error) {
        doPost(URL_ACCOUNT_GROUP_FRIEND_GROUP_CHAT_DEL, 'json', bodyData, success, error)
    }

    /**
     * 15.2 群聊添加好友任务停止群聊任务
     * @param bodyData{groupFriendId,groupchatId}
     * @param success
     * @param error
     */
    static getAccountGroupFriendGroupChatStop(bodyData, success, error) {
        doPost(URL_ACCOUNT_GROUP_FRIEND_GROUP_CHAT_STOP, 'json', bodyData, success, error)
    }

    /**
     * 15.2 群聊添加好友任务停止群聊任务
     * @param groupFriendId  任务ID
     * @param success
     * @param error
     */
    static getAccountGroupFriendOpen(groupFriendId, success, error) {
        doGet(URL_ACCOUNT_GROUP_FRIEND_OPEN + '?groupFriendId=' + groupFriendId, success, error)
    }

    /**
     * 15.2 获取群成员列表
     * @param groupId  群ID
     * @param success
     * @param error
     */
    static getAccountGroupFriendRoomMemberList(groupId, success, error) {
        doGet(URL_ACCOUNT_GROUP_FRIEND_ROOM_MEMBER_LIST + '?groupId=' + groupId, success, error)
    }

    /**
     *25 群标签
     * @param bodyData{name}
     * @param success
     * @param error
     */
    static getGroupTagQuery(bodyData, success, error) {
        doPost(URL_GROUP_TAG_QUERY, 'json', bodyData, success, error)
    }

    /**
     *02 群聊筛选列表
     * @param bodyData{name,managerId,tagFilter}
     * @param success
     * @param error
     */
    static getGroupSopQueryRoom(pageNum, pageSize, bodyData, success, error) {
        doPost(URL_GROUP_SOP_QUERY_ROOM + '?pageNum=' + pageNum + '&pageSize=' + pageSize, 'json', bodyData, success, error)
    }

    /**
     *05.1 群管理员列表
     * @param success
     * @param error
     */
    static getGroupManagerList(success, error) {
        doGet(URL_GROUP_MANAGER_MANAGE_LIST, success, error)
    }

    /**
     *04 获取群聊SOP任务列表
     * @param taskName
     * @param pageNum
     * @param pageSize
     * @param success
     * @param error
     */
    static getGroupSopTaskLsit(taskName, pageNum, pageSize, success, error) {
        doGet(URL_GROUP_SOP_TASK_LIST + '?taskName=' + taskName + '&pageNum=' + pageNum + '&pageSize=' + pageSize, success, error)
    }

    /**
     *07 群聊SOP任务名称列表
     * @param success
     * @param error
     */
    static getGroupSopNameList(success, error) {
        doGet(URL_GROUP_SOP_NAME_LIST, success, error)
    }

    /**
     *01 创建群聊SOP任务
     * @param bodyData
     * @param success
     * @param error
     */
    static getGroupSopCreate(bodyData, success, error) {
        doPost(URL_GROUP_SOP_CREATE, 'json', bodyData, success, error)
    }

    /**
     *05 关闭群聊SOP任务
     * @param taskId radio
     * @param success
     * @param error
     */
    static getGroupSopRadio(taskId, radio, success, error) {
        doPost(URL_GROUP_SOP_RADIO + '?taskId=' + taskId + '&radio=' + radio, 'json', {}, success, error)
    }

    /**
     *02 获取群聊SOP任务详情
     * @param taskId
     * @param success
     * @param error
     */
    static getGroupSopDetail(taskId, success, error) {
        doGet(URL_GROUP_SOP_DETAIL + '?taskId=' + taskId, success, error)
    }

    /**
     *03 编辑群聊SOP任务
     * @param bodyData
     * @param success
     * @param error
     */
    static getGroupSopEdit(bodyData, success, error) {
        doPost(URL_GROUP_SOP_EDIT, 'json', bodyData, success, error)
    }

    /**
     *06 删除群聊SOP任务
     * @param taskId
     * @param success
     * @param error
     */
    static getGroupSopDel(taskId, success, error) {
        doPost(URL_GROUP_SOP_DEL + '?taskId=' + taskId, 'json', {}, success, error)
    }

    /**
     *08 群聊管理
     * @param pageNum
     * @param pageSize
     * @param bodyData(taskId,groupName,accountId,tagIds,tagLogic)
     * @param success
     * @param error
     */
    static getGroupSopGroups(pageNum, pageSize, bodyData, success, error) {
        doPost(URL_GROUP_SOP_GROUPS + '?pageNum=' + pageNum + '&pageSize=' + pageSize, 'json', bodyData, success, error)
    }

    /**
     *07.1 群聊SOP任务群过滤类型
     * @param taskId
     * @param success
     * @param error
     */
    static getGroupSopTaskType(taskId, success, error) {
        doGet(URL_GROUP_SOP_TASK_TYPE + '?taskId=' + taskId, success, error)
    }

    /**
     *11 群聊管理修改过滤标签
     * @param taskId
     * @param pageNum
     * @param pageSize
     * @param bodyData
     * @param success
     * @param error
     */
    static getGroupSopEditTagFilter(taskId, bodyData, success, error) {
        doPost(URL_GROUP_SOP_EDIT_TAG_FILTER + '?taskId=' + taskId, 'json', bodyData, success, error)
    }

    /**
     *10 群聊管理修改群聊
     * @param taskId
     * @param groupIds
     * @param success
     * @param error
     */
    static getGroupSopEditGroup(taskId, groupIds, success, error) {
        doPost(URL_GROUP_SOP_EDIT_GROUP + '?taskId=' + taskId, 'json', groupIds, success, error)
    }

    /**
     *09 群聊管理移除群聊
     * @param taskId
     * @param groupIds
     * @param success
     * @param error
     */
    static getGroupSopDelGroup(taskId, groupIds, success, error) {
        doPost(URL_GROUP_SOP_DEL_GROUP + '?taskId=' + taskId, 'json', groupIds, success, error)
    }

    /**
     *12 群聊详情
     * @param taskId
     * @param pageNum
     * @param pageSize
     * @param bodyData
     * @param success
     * @param error
     */
    static getGroupSopGroupData(taskId, pageNum, pageSize, bodyData, success, error) {
        doPost(URL_GROUP_SOP_GROUP_DATA + '?taskId=' + taskId + '&pageNum=' + pageNum + '&pageSize=' + pageSize, 'json', bodyData, success, error)
    }

    /**
     *12 群聊详情  后改的
     * @param pageNum
     * @param pageSize
     * @param bodyData
     * @param success
     * @param error
     */
    static getGroupSopGroupPushHg(pageNum, pageSize, bodyData, success, error) {
        doPost(URL_GROUP_SOP_GROUP_PUSh + '?pageNum=' + pageNum + '&pageSize=' + pageSize, 'json', bodyData, success, error)
    }

    /**
     *16 成员详情
     * @param taskId
     * @param pageNum
     * @param pageSize
     * @param managerId
     * @param success
     * @param error
     */
    static getGroupSopManagerData(taskId, managerId, pageNum, pageSize, success, error) {
        doPost(URL_GROUP_SOP_MANAGER_DATA + '?taskId=' + taskId + '&managerId=' + managerId + '&pageNum=' + pageNum + '&pageSize=' + pageSize, 'json', {}, success, error)
    }

    /**
     *16 成员详情
     * @param taskId
     * @param pageNum
     * @param pageSize
     * @param groupId
     * @param success
     * @param error
     */
    static getGroupSopGroupPush(taskId, groupId, pageNum, pageSize, success, error) {
        doPost(URL_GROUP_SOP_GROUP_PUSH + '?taskId=' + taskId + '&groupId=' + groupId + '&pageNum=' + pageNum + '&pageSize=' + pageSize, 'json', {}, success, error)
    }

    /**
     *19 管理员群聊列表
     * @param taskId
     * @param managerId
     * @param success
     * @param error
     */
    static getGroupSopManagerGroup(taskId, managerId, success, error) {
        doGet(URL_GROUP_SOP_MANAGER_GROUP + '?taskId=' + taskId + '&managerId=' + managerId, success, error)
    }

    /**
     *18 管理员推送详情
     * @param taskId
     * @param managerId
     * @param groupId
     * @param success
     * @param error
     */
    static getGroupSopManagerPush(taskId, managerId, groupId, success, error) {
        doPost(URL_GROUP_SOP_MANAGER_PUSH + '?taskId=' + taskId + '&managerId=' + managerId + '&groupId=' + groupId, 'json', {}, success, error)
    }


    /**
     *18 Sop模板消息列表
     * @param pageNum
     * @param pageSize
     * @param bodyData
     * @param success
     * @param error
     */
    static getSopTemplateList(pageNum, pageSize, bodyData, success, error) {
        doPost(URL_SOP_TEMPLATE_LIST + '?pageNum=' + pageNum + '&pageSize=' + pageSize, 'json', bodyData, success, error)
    }

    /**
     *18 Sop模板创建
     * @param bodyData{templateName：，templateType：，postRule：[]}
     * @param success
     * @param error
     */
    static getSopTemplateCreate(bodyData, success, error) {
        doPost(URL_SOP_TEMPLATE_CREATE, 'json', bodyData, success, error)
    }

    /**
     *18 获取Sop模板的详情
     * @param ruleId
     * @param success
     * @param error
     */
    static getSopTemplateDetail(ruleId, success, error) {
        doGet(URL_SOP_TEMPLATE_DETAIL + '?ruleId=' + ruleId, success, error)
    }

    /**
     *18 Sop模板编辑
     * @param bodyData{templateName：，templateType：，postRule：[]}
     * @param success
     * @param error
     */
    static getSopTemplateEdit(bodyData, success, error) {
        doPost(URL_SOP_TEMPLATE_EDIT, 'json', bodyData, success, error)
    }

    /**
     *18 删除Sop模板
     * @param templateName
     * @param success
     * @param error
     */
    static getSopTemplateDel(templateId, success, error) {
        doPost(URL_SOP_TEMPLATE_DEL + '?templateId=' + templateId, 'json', {}, success, error)
    }

    /**
     *06 获取SOP模板名称列表

     * @param templateName
     * @param success
     * @param error
     */
    static getSopTemplateNameList(success, error) {
        doGet(URL_SOP_TEMPLATE_NAME_LIST, success, error)
    }


    //好友sop
    static getFriendSopTaskList(taskName, pageNum, pageSize, success, error) {
        doGet(URL_FRIEND_SOP_TASK_LIST + '?taskName=' + taskName + '&pageNum=' + pageNum + '&pageSize=' + pageSize, success, error)
    }

    /**
     *01 创建好友SOP任务
     * @param bodyData
     * @param success
     * @param error
     */
    static getFriendSopCreate(bodyData, success, error) {
        doPost(URL_FRIEND_SOP_CREATE, 'json', bodyData, success, error)
    }

    /**
     *05 开关好友SOP任务
     * @param taskId
     * @param radio
     * @param success
     * @param error
     */
    static getFriendSopRadio(taskId, radio, success, error) {
        doPost(URL_FRIEND_SOP_RADIO + '?taskId=' + taskId + '&radio=' + radio, 'json', {}, success, error)
    }

    /**
     *06 删除好友SOP任务
     * @param taskId
     * @param success
     * @param error
     */
    static getFriendSopDel(taskId, success, error) {
        doPost(URL_FRIEND_SOP_DEL + '?taskId=' + taskId, 'json', {}, success, error)
    }

    /**
     *07 好友SOP任务名称列表
     * @param success
     * @param error
     */
    static getFriendSopNameList(success, error) {
        doGet(URL_FRIEND_SOP_NAME_LIST, success, error)
    }

    /**
     *08 管理账号名称列表
     * @param taskId
     * @param success
     * @param error
     */
    static getFriendSopManagerList(taskId, success, error) {
        doGet(URL_FRIEND_SOP_MANAGER_LIST + '?taskId=' + taskId, success, error)
    }

    /**
     *02 获取好友SOP任务详情
     * @param taskId
     * @param success
     * @param error
     */
    static getFriendSopDetail(taskId, success, error) {
        doGet(URL_FRIEND_SOP_DETAIL + '?taskId=' + taskId, success, error)
    }

    /**
     *03 编辑好友SOP任务
     * @param bodyData
     * @param success
     * @param error
     */
    static getFriendSopEdit(bodyData, success, error) {
        doPost(URL_FRIEND_SOP_EDIT, 'json', bodyData, success, error)
    }

    /**
     *12 数据详情
     * @param taskId
     * @param pageNum
     * @param pageSize
     * @param bodyData
     * @param success
     * @param error
     */
    static getFriendSopPushData(taskId, pageNum, pageSize, bodyData, success, error) {
        doPost(URL_FRIEND_SOP_PUSH_DATA + '?taskId=' + taskId + '&pageNum=' + pageNum + '&pageSize=' + pageSize, 'json', bodyData, success, error)
    }

    /**
     *03.1 查看人数
     * @param bodyData
     * @param success
     * @param error
     */
    static getFriendSopCustomerNum(bodyData, success, error) {
        doPost(URL_FRIEND_SOP_CUSTOMER_NUM, 'json', bodyData, success, error)
    }


    /**
     *17 黑名单清单
     * @param name
     * @param pageSize
     * @param pageNum
     */
    static getGroupBlackListCustomerList(name, pageNum, pageSize, success, error) {
        doGet(URL_GROUP_BLACK_LIST_CUSTOMER_LIST + '?name=' + name + '&pageNum=' + pageNum + '&pageSize=' + pageSize, success, error)
    }

    /**
     *16 从黑名单移除客户
     * @param bodyData:{customerId:''}
     */
    static getGroupBlackListDelCustomer(bodyData, success, error) {
        doPost(URL_GROUP_BLACK_LIST_DEL_CUSTOMER, 'json', bodyData, success, error)
    }

    /**
     *15.1 黑名单客户列表
     * @param name
     * @param pageNum
     * @param pageSize
     */
    static getGroupBlackListSelectCustomer(name, pageNum, pageSize, success, error) {
        doGet(URL_GROUP_BLACK_LIST_SELECT_CUSTOMER + '?name=' + name + '&pageNum=' + pageNum + '&pageSize=' + pageSize, success, error)
    }

    /**
     *15 手动添加客户到黑名单
     * @param bodyData{customers:[{customerId:''}],reason:''}
     */
    static getGroupBlackListAddCustomer(bodyData, success, error) {
        doPost(URL_GROUP_BLACK_LIST_ADD_CUSTOMER, 'json', bodyData, success, error)
    }

    /**
     *20 白名单客户列表
     * @param name
     * @param pageSize
     * @param pageNum
     */
    static getGroupWhiteListSelectCustomer(name, pageNum, pageSize, success, error) {
        doGet(URL_GROUP_WHITE_LIST_SELECT_CUSTOMER + '?name=' + name + '&pageNum=' + pageNum + '&pageSize=' + pageSize, success, error)
    }

    /**
     *20 白名单清单
     * @param name
     * @param pageSize
     * @param pageNum
     */
    static getGroupWhiteListCustomerList(name, pageNum, pageSize, success, error) {
        doGet(URL_GROUP_WHITE_LIST_CUSTOMER_LIST + '?name=' + name + '&pageNum=' + pageNum + '&pageSize=' + pageSize, success, error)
    }

    /**
     *15 手动添加客户到白名单
     * @param bodyData{customers:[{customerId:''}],reason:''}
     */
    static getGroupWhiteListAddCustomer(bodyData, success, error) {
        doPost(URL_GROUP_WHITE_LIST_ADD_CUSTOMER, 'json', bodyData, success, error)
    }

    /**
     *16 从白名单移除客户
     * @param bodyData:{customerId:''}
     */
    static getGroupWhiteListDelCustomer(bodydata, success, error) {
        doPost(URL_GROUP_WHITE_LIST_DEL_CUSTOMER, 'json', bodydata, success, error)
    }

    /**
     *23 内容白名单网页清单
     * @param pageNum
     * @param pageSize
     */
    static getGroupWhiteListContentLinkList(pageNum, pageSize, success, error) {
        doGet(URL_GROUP_WHITE_LIST_CONTENT_LINK_LIST + '?pageNum=' + pageNum + '&pageSize=' + pageSize, success, error)
    }

    /**
     *22 从内容白名单移除网页
     * @param bodyData:{id:''}
     */
    static getGroupWhiteListContentDelLink(bodyData, success, error) {
        doPost(URL_GROUP_WHITE_LIST_CONTENT_DEL_LINK, 'json', bodyData, success, error)
    }

    /**
     *21 添加内容白名单网页
     * @param bodyData:{linkUrl:''}
     */
    static getGroupWhiteListContentAddLink(bodyData, success, error) {
        doPost(URL_GROUP_WHITE_LIST_CONTENT_ADD_LINK, 'json', bodyData, success, error)
    }

    /**
     *26 内容白名单小程序清单
     * @param pageNum
     * @param pageSize
     */
    static getGroupWhiteListContentAppList(pageNum, pageSize, success, error) {
        doGet(URL_GROUP_WHITE_LIST_CONTENT_APP_LIST + '?pageNum=' + pageNum + '&pageSize=' + pageSize, success, error)
    }

    /**
     *24 添加内容白名单小程序
     * @param bodyData:{appId:''}
     */
    static getGroupWhiteListContentAddApp(bodyData, success, error) {
        doPost(URL_GROUP_WHITE_LIST_CONTENT_ADD_APP, 'json', bodyData, success, error)
    }

    /**
     *25 从内容白名单移除小程序
     * @param bodyData:{id:''}
     */
    static getGroupWhiteListContentDelApp(bodyData, success, error) {
        doPost(URL_GROUP_WHITE_LIST_CONTENT_DEL_APP, 'json', bodyData, success, error)
    }

    /**
     *获取用户Id
     * @param bodyData:{id:''}
     */
    static getChatUserID(success, error) {
        doGet(URL_CHAT_USER_ID, success, error)
    }

    /**
     *01 获取关联的账号
     */
    static getChatAccountList(success, error) {
        doGet(URL_GET_CHAT_ACCOUNT_LIST, success, error)
    }

    /**
     *02 聊天对话列表
     * @param wxid
     */
    static getChatList(wxid, success, error) {
        doGet(URL_GET_CHAT_LIST + '?wxid=' + wxid, success, error)
    }

    /**
     *15 获取聊天群基本信息
     * @param bodyData{wxid:'',chat_wxid:''}
     */
    static getChatGroupInfo(bodyData, success, error) {
        doPost(URL_GET_CHAT_GET_GROUP_INFO, 'json', bodyData, success, error)
    }

    /**
     *06.4 结束会话
     * @param bodyData{wxid:'',chat_wxid:''}
     */
    static getChatEndConveerSattion(bodyData, success, error) {
        doPost(URL_CHAT_END_CONVEER_SATION, 'json', bodyData, success, error)
    }

    /**
     *06.4 置顶
     * @param bodyData{wxid:'',chat_wxid:'',radio:1 设置为置顶 0 取消置顶}
     */
    static getChatSetTop(bodyData, success, error) {
        doPost(URL_CHAT_SET_TOP, 'json', bodyData, success, error)
    }

    /**
     *设置未读
     * @param bodyData{wxid:'',chat_wxid:'',radio:1 设置为置顶 0 取消置顶}
     */
    static getChatSetUnRead(bodyData, success, error) {
        doPost(URL_CHAT_SET_UNREAD, 'json', bodyData, success, error)
    }

    /**
     *设置消息免打扰
     * @param bodyData{wxid:'',chat_wxid:'',radio:1 设置为置顶 0 取消置顶}
     */
    static getChatSetNotDisturb(bodyData, success, error) {
        doPost(URL_CHAT_SET_NOT_DISTURB, 'json', bodyData, success, error)
    }

    /**
     *23 退出群聊
     * @param bodyData{wxid:'',chat_wxid:''}
     */
    static getChatQuitRoom(bodyData, success, error) {
        doPost(URL_CHAT_QUIT_ROOM, 'json', bodyData, success, error)
    }

    /**
     *06 清空聊天列表
     * @param wxid
     */
    static getChatClearChatList(wxid, success, error) {
        doGet(URL_CHAT_CLEAR_CHAT_LIST + '?wxid=' + wxid, success, error)
    }

    /**
     *19 获取账号客户列表
     * @param pageSize
     * @param pageNum
     * @param bodyData
     */
    static getChatGetCustomers(pageSize, pageNum, bodyData, success, error) {
        doPost(URL_CHAT_GET_CUSTOMERS + '?pageSize=' + pageSize + '&pageNum=' + pageNum, 'json', bodyData, success, error)
    }

    static getChatGetCustomersSelectAll(bodyData, success, error) {
        doPost(URL_CHAT_GET_CUSTOMERS_SELECT_ALL, 'json', bodyData, success, error)
    }

    /**
     *20 获取账号企业成员列表
     * @param pageSize
     * @param pageNum
     * @param bodyData
     */
    static getChatWorkMates(pageSize, pageNum, bodyData, success, error) {
        doPost(URL_CHAT_GET_WORK_MATES + '?pageSize=' + pageSize + '&pageNum=' + pageNum, 'json', bodyData, success, error)
    }

    /**
     *20.2 新建群聊
     * @param bodyData:{wxid:'',roomName:'',ids:[]}
     */
    static getChatCreateChatRoom(bodyData, success, error) {
        doPost(URL_CHAT_CREATE_CHAT_ROOM, 'json', bodyData, success, error)
    }

    /**
     *16 编辑聊天群公告
     * @param bodyData:{wxid:'',chat_wxid:'',announce:''}
     */
    static getChatEditGroupAnnounce(bodyData, success, error) {
        doPost(URL_CHAT_EDIT_GROUP_ANNOUNCE, 'json', bodyData, success, error)
    }

    /**
     *18 添加聊天群标签
     * @param bodyData:{wxid:'',chat_wxid:'',tagIds:''}
     */
    static getChatAddGroupTag(bodyData, success, error) {
        doPost(URL_CHAT_ADD_GROUP_TAG, 'json', bodyData, success, error)
    }

    /**
     *17 删除聊天群标签
     * @param bodyData:{wxid:'',chat_wxid:'',tagIds:''}
     */
    static getChatDelGroupTag(bodyData, success, error) {
        doPost(URL_CHAT_DEL_GROUP_TAG, 'json', bodyData, success, error)
    }

    /**
     *21 邀请客户/企业成员入群
     * @param bodyData:{wxid:'',chat_wxid:'',customerIds:''}
     */
    static getChatInviteToGroup(bodyData, success, error) {
        doPost(URL_CHAT_INVITE_TO_GROUP, 'json', bodyData, success, error)
    }

    /**
     *22 群聊踢出客户/企业成员
     * @param bodyData:{wxid:'',chat_wxid:'',customerIds:''}
     */
    static getChatRemoveFromGroup(bodyData, success, error) {
        doPost(URL_CHAT_REMOVE_FROM_GROUP, 'json', bodyData, success, error)
    }

    /**
     *30 获取私聊客户基本信息
     * @param bodyData:{wxid:'',chat_wxid:''}
     */
    static getChatGetCustomerInfo(bodyData, success, error) {
        doPost(URL_CHAT_GET_CUSTOMER_INFO, 'json', bodyData, success, error)
    }

    /**
     *31 编辑聊天客户备注
     * @param bodyData:{wxid:'',chat_wxid:'',remark:"}
     */
    static getChatEditCustomerRemark(bodyData, success, error) {
        doPost(URL_CHAT_EDIT_CUSTOMER_REMARK, 'json', bodyData, success, error)
    }

    /**
     *31 编辑聊天客户描述
     * @param bodyData:{wxid:'',chat_wxid:'',remark:"}
     */
    static getChatEditCustomerDesc(bodyData, success, error) {
        doPost(URL_CHAT_EDIT_CUSTOMER_DESC, 'json', bodyData, success, error)
    }

    /**
     *34 添加聊天客户标签
     * @param bodyData:{wxid:'',chat_wxid:'',tagId:[]}
     */
    static getChatAddCustomerTag(bodyData, success, error) {
        doPost(URL_CHAT_ADD_CUSTOMER_TAG, 'json', bodyData, success, error)
    }

    /**
     *33 删除聊天客户标签
     * @param bodyData:{wxid:'',chat_wxid:'',tagId:"}
     */
    static getChatDelCustomerTag(bodyData, success, error) {
        doPost(URL_CHAT_DEL_CUSTOMER_TAG, 'json', bodyData, success, error)
    }

    /**
     *32.1 编辑聊天客户
     * @param bodyData:{wxid:'',chat_wxid:'',remark:",desc:'',mobile:''}
     */
    static getChatEditCustomerNewAdd(bodyData, success, error) {
        doPost(URL_CHAT_EDIT_CUSTOMER_NEW_ADD, 'json', bodyData, success, error)
    }

    /**
     *20.1 发起聊天
     * @param bodyData:{wxid:'',chat_wxid:'',isRoom:"}
     */
    static getChatPostChat(bodyData, success, error) {
        doPost(URL_CHAT_POST_CHAT, 'json', bodyData, success, error)
    }

    /**
     *关闭当前的联系人
     * @param bodyData:{wxid:'',chat_wxid:'',isRoom:"}
     */
    static getChatRadio(bodyData, success, error) {
        doPost(URL_CHAT_RADIO, 'json', bodyData, success, error)
    }

    /**
     *聊天账号置顶
     * @param bodyData:{wxwUserId:'',topFlag:''}
     */
    static getAccountTopFlag(bodyData, success, error) {
        doPost(URL_CHAT_ACCOUNT_TOP_FLAG, 'json', bodyData, success, error)
    }

    /**
     *04 任务列表
     * @param pageNum
     * @param pageSize
     * @param bodyData{taskName:'',groupName:'',status:''}
     */
    static getWxwPullGroupList(pageNum, pageSize, bodyData, success, error) {
        doPost(URL_WXW_PULL_GROUP_LIST + '?pageNum=' + pageNum + '&pageSize=' + pageSize, 'json', bodyData, success, error)
    }

    /**
     *13 获取客户信息
     * @param pageNum
     * @param pageSize
     * @param bodyData{wxwUserIds:[],nickName:''}
     */
    static getWxwPullGroupGetCustomers(pageNum, pageSize, bodyData, success, error) {
        doPost(URL_WXW_PULL_GROUP_GET_CUSTOMERS + '?pageNum=' + pageNum + '&pageSize=' + pageSize, 'json', bodyData, success, error)
    }

    /**
     *13 创建任务
     * @param bodyData{}
     */
    static getWxwPullGroupCreate(bodyData, success, error) {
        doPost(URL_WXW_PULL_GROUP_CREATE, 'json', bodyData, success, error)
    }

    /**
     *任务详情
     * @param taskId
     */
    static getPullGroupDetail(taskId, success, error) {
        doGet(URL_WXW_PULL_GROUP_DETAIL + '?taskId=' + taskId, success, error)
    }

    /**
     *编辑任务
     * @param bodyData
     */
    static getPullGroupEdit(bodyData, success, error) {
        doPost(URL_WXW_PULL_GROUP_EDIT, 'json', bodyData, success, error)
    }

    /**
     *删除任务
     * @param taskId
     */
    static getPullGroupDelete(taskId, success, error) {
        doGet(URL_WXW_PULL_GROUP_DELETE + '?taskId=' + taskId, success, error)
    }

    /**
     *停止任务
     * @param taskId
     */
    static getPullGroupStop(taskId, success, error) {
        doGet(URL_WXW_PULL_GROUP_STOP + '?taskId=' + taskId, success, error)
    }

    /**
     *开启任务
     * @param taskId
     */
    static getPullGroupStart(taskId, success, error) {
        doGet(URL_WXW_PULL_GROUP_START + '?taskId=' + taskId, success, error)
    }

    /**
     *统计人数
     * @param bodyData
     */
    static getPullGroupCountNum(bodyData, success, error) {
        doPost(URL_WXW_PULL_GROUP_COUNT_NUM, 'json', bodyData, success, error)
    }

    /**
     *活动下拉
     */
    static getPullGroupMenuList(success, error) {
        doGet(URL_WXW_PULL_GROUP_MENU_LIST, success, error)
    }

    /**
     *任务详情 基本信息
     */
    static getPullGroupTaskDetailBasinInfo(taskId, success, error) {
        doGet(URL_WXW_PULL_GROUP_TASK_DETAIL_BASIN_INFO + '?taskId=' + taskId, success, error)
    }

    /**
     *入群客户
     * @param pageNum
     * @param pageSize
     * @param taskId
     * @param bodyData
     */
    static getPullGroupEnterCusotmer(pageNum, pageSize, taskId, bodyData, success, error) {
        doPost(URL_WXW_PULL_GROUP_ENTER_CUSOTMER + '?pageNum=' + pageNum + '&pageSize=' + pageSize + '&taskId=' + taskId, 'json', bodyData, success, error)
    }

    /**
     *已建群聊
     * @param pageNum
     * @param pageSize
     * @param taskId
     * @param bodyData
     */
    static getPullGroupRoomList(pageNum, pageSize, taskId, bodyData, success, error) {
        doPost(URL_WXW_PULL_GROUP_ROOM_LIST + '?pageNum=' + pageNum + '&pageSize=' + pageSize + '&taskId=' + taskId, 'json', bodyData, success, error)
    }

    /**
     *新组建的选择群聊
     * @param pageNum
     * @param pageSize
     * @param bodyData
     */
    static getGroupManagerAccountRooms(pageSize, pageNum, bodyData, success, error) {
        doPost(URL_GROUP_MANAGER_ACCOUNT_ROOMS + '?pageNum=' + pageNum + '&pageSize=' + pageSize, 'json', bodyData, success, error)
    }

    static getGroupManagerAccountRoomsSelectAll(bodyData, success, error) {
        doPost(URL_GROUP_MANAGER_ACCOUNT_ROOMS_SELECT_ALL, 'json', bodyData, success, error)
    }

    //话术库
    /**
     *00 话术分组创建
     * @param bodyData
     * @param success
     * @param error
     */
    static getChatLibGroupCreate(bodyData, success, error) {
        doPost(URL_CHAT_LIB_GROUP_CREATE, 'json', bodyData, success, error)
    }

    /**
     *01 话术分组列表
     * @param success
     * @param error
     */
    static getChatLibGroupList(success, error) {
        doGet(URL_CHAT_LIB_GROUP_LIST, success, error)
    }

    /**
     *02 话术分组修改名称
     * @param bodyData
     * @param success
     * @param error
     */
    static getChatLibGroupEdit(bodyData, success, error) {
        doPost(URL_CHAT_LIB_GROUP_EDIT, 'json', bodyData, success, error)
    }

    /**
     *03 话术分组删除
     * @param bodyData
     * @param success
     * @param error
     */
    static getChatLibGroupDel(bodyData, success, error) {
        doPost(URL_CHAT_LIB_GROUP_DEL, 'json', bodyData, success, error)
    }

    /**
     *04 话术列表
     * @param pageNum
     * @param pageSize
     * @param bodyData
     * @param success
     * @param error
     */
    static getChatLibList(pageNum, pageSize, bodyData, success, error) {
        doPost(URL_CHAT_LIB_LIST + '?pageNum=' + pageNum + '&pageSize=' + pageSize, 'json', bodyData, success, error)
    }

    /**
     *05 话术创建
     * @param bodyData
     * @param success
     * @param error
     */
    static getChatLibCreate(bodyData, success, error) {
        doPost(URL_CHAT_LIB_CREATE, 'json', bodyData, success, error)
    }

    /**
     *06 话术列表聊天栏
     * @param bodyData
     * @param success
     * @param error
     */
    static getChatLibContentList(pageNum, pageSize, bodyData, success, error) {
        doPost(URL_CHAT_LIB_CONTENT_LIST + '?pageNum=' + pageNum + '&pageSize=' + pageSize, 'json', bodyData, success, error)
    }

    /**
     *07 话术详情
     * @param chatId
     * @param success
     * @param error
     */
    static getChatLibDetail(chatId, success, error) {
        doGet(URL_CHAT_LIB_DETAIL + '?chatId=' + chatId, success, error)
    }

    /**
     *08 话术编辑
     * @param bodyData
     * @param success
     * @param error
     */
    static getChatLibEdit(bodyData, success, error) {
        doPost(URL_CHAT_LIB_EDIT, 'json', bodyData, success, error)
    }

    /**
     *09 话术删除
     * @param chatId
     * @param success
     * @param error
     */
    static getChatLibDel(chatId, success, error) {
        doGet(URL_CHAT_LIB_DEL + '?chatId=' + chatId, success, error)
    }

    /**
     *10 交换话术顺序
     * @param bodyData
     * @param success
     * @param error
     */
    static getChatLibSwaporder(bodyData, success, error) {
        doPost(URL_CHAT_LIB_SWAPORDER, 'json', bodyData, success, error)
    }

    /**
     *11 发送话术
     * @param chatId
     * @param success
     * @param error
     */
    static getChatLibSend(chatId, success, error) {
        doGet(URL_CHAT_LIB_SEND + '?chatId=' + chatId, success, error)
    }

    //素材库
    /**
     *01 素材分组创建
     * @param bodyData{groupName:''}
     * @param success
     * @param error
     */
    static getCustomerMediaGroupsCreate(bodyData, success, error) {
        doPost(URL_CUSTOMER_MEDIA_GROUPS_CREATE, 'json', bodyData, success, error)
    }

    /**
     *02 素材分组列表
     * @param success
     * @param error
     */
    static getCustomerMediaGroupsList(success, error) {
        doGet(URL_CUSTOMER_MEDIA_GROUPS_LIST, success, error)
    }

    /**
     *03 素材分组编辑
     * @param bodyData{groupName:'',groupId}
     * @param success
     * @param error
     */
    static getCustomerMediaGroupsRename(bodyData, success, error) {
        doPost(URL_CUSTOMER_MEDIA_GROUPS_RENAME, 'json', bodyData, success, error)
    }

    /**
     *03 删除素材分组
     * @param bodyData{groupId}
     * @param success
     * @param error
     */
    static getCustomerMediaGroupsDel(bodyData, success, error) {
        doPost(URL_CUSTOMER_MEDIA_GROUPS_DEL, 'json', bodyData, success, error)
    }

    /**
     *05 素材创建
     * @param bodyData{}
     * @param success
     * @param error
     */
    static getCustomerMediaCreate(bodyData, success, error) {
        doPost(URL_CUSTOMER_MEDIA_CREATE, 'json', bodyData, success, error)
    }

    /**
     *06 素材详情
     * @param mediaId
     * @param success
     * @param error
     */
    static getCustomerMediaDetail(mediaId, success, error) {
        doGet(URL_CUSTOMER_MEDIA_DETAIL + '?mediaId=' + mediaId, success, error)
    }

    /**
     *06 素材创建列表
     * @param bodyData{name:'',groupId:'',type:'}
     * @param success
     * @param error
     */
    static getCustomerMediaList(pageNum, pageSize, bodyData, success, error) {
        doPost(URL_CUSTOMER_MEDIA_LIST + '?pageNum=' + pageNum + '&pageSize=' + pageSize, 'json', bodyData, success, error)
    }

    /**
     *07 素材编辑
     * @param bodyData{}
     * @param success
     * @param error
     */
    static getCustomerMediaEdit(bodyData, success, error) {
        doPost(URL_CUSTOMER_MEDIA_EDIT, 'json', bodyData, success, error)
    }

    /**
     *08 素材删除
     * @param bodyData{mediaId}
     * @param success
     * @param error
     */
    static getCustomerMediaDel(bodyData, success, error) {
        doPost(URL_CUSTOMER_MEDIA_DEL, 'json', bodyData, success, error)
    }

    /**
     *09 素材创建手机端上传开关
     * @param bodyData:{radio:}
     * @param success
     * @param error
     */
    static getCustomerMediaPhoneUploadRadio(bodyData, success, error) {
        doPost(URL_CUSTOMER_MEDIA_PHONE_UPLOAD_RADIO, 'json', bodyData, success, error)
    }

    /**
     *10 素材创建手机端上传状态
     * @param success
     * @param error
     */
    static getCustomerMediaPhoneUploadStatus(success, error) {
        doGet(URL_CUSTOMER_MEDIA_PHONE_UPLOAD_STATUS, success, error)
    }


    //子账户
    /**
     *获取角色列表
     * @param success
     * @param error
     */
    static getSubAccountRoleList(success, error) {
        doGet(URL_SUB_ACCOUNT_ROLE_LIST, success, error)
    }

    /**
     *创建角色
     * @param bodyData
     * @param success
     * @param error
     */
    static getSubAccountRoleCreate(bodyData, success, error) {
        doPost(URL_SUB_ACCOUNT_ROLE_CREATE, 'json', bodyData, success, error)
    }

    /**
     *编辑角色
     * @param bodyData
     * @param success
     * @param error
     */
    static getSubAccountRoleEditName(bodyData, success, error) {
        doPost(URL_SUB_ACCOUNT_ROLE_EDIT_NAME, 'json', bodyData, success, error)
    }

    /**
     *删除角色
     * @param bodyData
     * @param success
     * @param error
     */
    static getSubAccountRoleDelete(bodyData, success, error) {
        doPost(URL_SUB_ACCOUNT_ROLE_DELETE, 'json', bodyData, success, error)
    }

    /**
     * 获取角色配置
     * @param roleId
     * @param success
     * @param error
     */
    static getSubAccountRoleConf(roleId, success, error) {
        doGet(URL_SUB_ACCOUNT_ROLE_CONF + '?roleId=' + roleId, success, error)
    }

    /**
     * 编辑角色配置
     * @param bodyData
     * @param success
     * @param error
     */
    static getSubAccountRoleEditConf(bodyData, success, error) {
        doPost(URL_SUB_ACCOUNT_ROLE_EDIT_CONF, 'json', bodyData, success, error)
    }

    /**
     * 获取登录扫码结果
     * @param loginQrcodeKey
     * @param success
     * @param error
     */
    static loginScanResult(loginQrcodeKey, key, success, error) {
        doGet(URL_LOGIN_SCAN_RESULT + `?loginQrcodeKey=${loginQrcodeKey}&key=${key}`, success, error)
    }

    /**
     * 登录验证
     * @param bodyData
     * @param success
     * @param error
     */
    static loginVerify(bodyData, success, error) {
        doPost(URL_LOGIN_VERIFY, 'json', bodyData, success, error)
    }
}

export default CloudApi